
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6156"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6156"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("fjfo2", function(module, exports) {
// randomColor by David Merfield under the CC0 license
// https://github.com/davidmerfield/randomColor/
(function(root, factory) {
    var randomColor = factory();
    // Support NodeJS & Component, which allow module.exports to be a function
    if (module && module.exports) exports = module.exports = randomColor;
    // Support CommonJS 1.1.1 spec
    exports.randomColor = randomColor;
})(this, function() {
    // Seed to get repeatable colors
    var seed = null;
    // Shared color dictionary
    var colorDictionary = {};
    // Populate the color dictionary
    loadColorBounds();
    // check if a range is taken
    var colorRanges = [];
    var randomColor = function(options) {
        options = options || {};
        // Check if there is a seed and ensure it's an
        // integer. Otherwise, reset the seed value.
        if (options.seed !== undefined && options.seed !== null && options.seed === parseInt(options.seed, 10)) seed = options.seed;
        else if (typeof options.seed === 'string') seed = stringToInteger(options.seed);
        else if (options.seed !== undefined && options.seed !== null) throw new TypeError('The seed value must be an integer or string');
        else seed = null;
        var H, S, B;
        // Check if we need to generate multiple colors
        if (options.count !== null && options.count !== undefined) {
            var totalColors = options.count, colors = [];
            // Value false at index i means the range i is not taken yet.
            for(var i = 0; i < options.count; i++)colorRanges.push(false);
            options.count = null;
            while(totalColors > colors.length){
                var color = randomColor(options);
                if (seed !== null) options.seed = seed;
                colors.push(color);
            }
            options.count = totalColors;
            return colors;
        }
        // First we pick a hue (H)
        H = pickHue(options);
        // Then use H to determine saturation (S)
        S = pickSaturation(H, options);
        // Then use S and H to determine brightness (B).
        B = pickBrightness(H, S, options);
        // Then we return the HSB color in the desired format
        return setFormat([
            H,
            S,
            B
        ], options);
    };
    function pickHue(options) {
        if (colorRanges.length > 0) {
            var hueRange = getRealHueRange(options.hue);
            var hue = randomWithin(hueRange);
            //Each of colorRanges.length ranges has a length equal approximatelly one step
            var step = (hueRange[1] - hueRange[0]) / colorRanges.length;
            var j = parseInt((hue - hueRange[0]) / step);
            //Check if the range j is taken
            if (colorRanges[j] === true) j = (j + 2) % colorRanges.length;
            else colorRanges[j] = true;
            var min = (hueRange[0] + j * step) % 359, max = (hueRange[0] + (j + 1) * step) % 359;
            hueRange = [
                min,
                max
            ];
            hue = randomWithin(hueRange);
            if (hue < 0) hue = 360 + hue;
            return hue;
        } else {
            var hueRange = getHueRange(options.hue);
            hue = randomWithin(hueRange);
            // Instead of storing red as two seperate ranges,
            // we group them, using negative numbers
            if (hue < 0) hue = 360 + hue;
            return hue;
        }
    }
    function pickSaturation(hue, options) {
        if (options.hue === 'monochrome') return 0;
        if (options.luminosity === 'random') return randomWithin([
            0,
            100
        ]);
        var saturationRange = getSaturationRange(hue);
        var sMin = saturationRange[0], sMax = saturationRange[1];
        switch(options.luminosity){
            case 'bright':
                sMin = 55;
                break;
            case 'dark':
                sMin = sMax - 10;
                break;
            case 'light':
                sMax = 55;
                break;
        }
        return randomWithin([
            sMin,
            sMax
        ]);
    }
    function pickBrightness(H, S, options) {
        var bMin = getMinimumBrightness(H, S), bMax = 100;
        switch(options.luminosity){
            case 'dark':
                bMax = bMin + 20;
                break;
            case 'light':
                bMin = (bMax + bMin) / 2;
                break;
            case 'random':
                bMin = 0;
                bMax = 100;
                break;
        }
        return randomWithin([
            bMin,
            bMax
        ]);
    }
    function setFormat(hsv, options) {
        switch(options.format){
            case 'hsvArray':
                return hsv;
            case 'hslArray':
                return HSVtoHSL(hsv);
            case 'hsl':
                var hsl = HSVtoHSL(hsv);
                return 'hsl(' + hsl[0] + ', ' + hsl[1] + '%, ' + hsl[2] + '%)';
            case 'hsla':
                var hslColor = HSVtoHSL(hsv);
                var alpha = options.alpha || Math.random();
                return 'hsla(' + hslColor[0] + ', ' + hslColor[1] + '%, ' + hslColor[2] + '%, ' + alpha + ')';
            case 'rgbArray':
                return HSVtoRGB(hsv);
            case 'rgb':
                var rgb = HSVtoRGB(hsv);
                return 'rgb(' + rgb.join(', ') + ')';
            case 'rgba':
                var rgbColor = HSVtoRGB(hsv);
                var alpha = options.alpha || Math.random();
                return 'rgba(' + rgbColor.join(', ') + ', ' + alpha + ')';
            default:
                return HSVtoHex(hsv);
        }
    }
    function getMinimumBrightness(H, S) {
        var lowerBounds = getColorInfo(H).lowerBounds;
        for(var i = 0; i < lowerBounds.length - 1; i++){
            var s1 = lowerBounds[i][0], v1 = lowerBounds[i][1];
            var s2 = lowerBounds[i + 1][0], v2 = lowerBounds[i + 1][1];
            if (S >= s1 && S <= s2) {
                var m = (v2 - v1) / (s2 - s1), b = v1 - m * s1;
                return m * S + b;
            }
        }
        return 0;
    }
    function getHueRange(colorInput) {
        if (typeof parseInt(colorInput) === 'number') {
            var number = parseInt(colorInput);
            if (number < 360 && number > 0) return [
                number,
                number
            ];
        }
        if (typeof colorInput === 'string') {
            if (colorDictionary[colorInput]) {
                var color = colorDictionary[colorInput];
                if (color.hueRange) return color.hueRange;
            } else if (colorInput.match(/^#?([0-9A-F]{3}|[0-9A-F]{6})$/i)) {
                var hue = HexToHSB(colorInput)[0];
                return [
                    hue,
                    hue
                ];
            }
        }
        return [
            0,
            360
        ];
    }
    function getSaturationRange(hue) {
        return getColorInfo(hue).saturationRange;
    }
    function getColorInfo(hue) {
        // Maps red colors to make picking hue easier
        if (hue >= 334 && hue <= 360) hue -= 360;
        for(var colorName in colorDictionary){
            var color = colorDictionary[colorName];
            if (color.hueRange && hue >= color.hueRange[0] && hue <= color.hueRange[1]) return colorDictionary[colorName];
        }
        return 'Color not found';
    }
    function randomWithin(range) {
        if (seed === null) {
            //generate random evenly destinct number from : https://martin.ankerl.com/2009/12/09/how-to-create-random-colors-programmatically/
            var golden_ratio = 0.618033988749895;
            var r = Math.random();
            r += golden_ratio;
            r %= 1;
            return Math.floor(range[0] + r * (range[1] + 1 - range[0]));
        } else {
            //Seeded random algorithm from http://indiegamr.com/generate-repeatable-random-numbers-in-js/
            var max = range[1] || 1;
            var min = range[0] || 0;
            seed = (seed * 9301 + 49297) % 233280;
            var rnd = seed / 233280.0;
            return Math.floor(min + rnd * (max - min));
        }
    }
    function HSVtoHex(hsv) {
        var rgb = HSVtoRGB(hsv);
        function componentToHex(c) {
            var hex = c.toString(16);
            return hex.length == 1 ? '0' + hex : hex;
        }
        var hex = '#' + componentToHex(rgb[0]) + componentToHex(rgb[1]) + componentToHex(rgb[2]);
        return hex;
    }
    function defineColor(name, hueRange, lowerBounds) {
        var sMin = lowerBounds[0][0], sMax = lowerBounds[lowerBounds.length - 1][0], bMin = lowerBounds[lowerBounds.length - 1][1], bMax = lowerBounds[0][1];
        colorDictionary[name] = {
            hueRange: hueRange,
            lowerBounds: lowerBounds,
            saturationRange: [
                sMin,
                sMax
            ],
            brightnessRange: [
                bMin,
                bMax
            ]
        };
    }
    function loadColorBounds() {
        defineColor('monochrome', null, [
            [
                0,
                0
            ],
            [
                100,
                0
            ]
        ]);
        defineColor('red', [
            -26,
            18
        ], [
            [
                20,
                100
            ],
            [
                30,
                92
            ],
            [
                40,
                89
            ],
            [
                50,
                85
            ],
            [
                60,
                78
            ],
            [
                70,
                70
            ],
            [
                80,
                60
            ],
            [
                90,
                55
            ],
            [
                100,
                50
            ]
        ]);
        defineColor('orange', [
            18,
            46
        ], [
            [
                20,
                100
            ],
            [
                30,
                93
            ],
            [
                40,
                88
            ],
            [
                50,
                86
            ],
            [
                60,
                85
            ],
            [
                70,
                70
            ],
            [
                100,
                70
            ]
        ]);
        defineColor('yellow', [
            46,
            62
        ], [
            [
                25,
                100
            ],
            [
                40,
                94
            ],
            [
                50,
                89
            ],
            [
                60,
                86
            ],
            [
                70,
                84
            ],
            [
                80,
                82
            ],
            [
                90,
                80
            ],
            [
                100,
                75
            ]
        ]);
        defineColor('green', [
            62,
            178
        ], [
            [
                30,
                100
            ],
            [
                40,
                90
            ],
            [
                50,
                85
            ],
            [
                60,
                81
            ],
            [
                70,
                74
            ],
            [
                80,
                64
            ],
            [
                90,
                50
            ],
            [
                100,
                40
            ]
        ]);
        defineColor('blue', [
            178,
            257
        ], [
            [
                20,
                100
            ],
            [
                30,
                86
            ],
            [
                40,
                80
            ],
            [
                50,
                74
            ],
            [
                60,
                60
            ],
            [
                70,
                52
            ],
            [
                80,
                44
            ],
            [
                90,
                39
            ],
            [
                100,
                35
            ]
        ]);
        defineColor('purple', [
            257,
            282
        ], [
            [
                20,
                100
            ],
            [
                30,
                87
            ],
            [
                40,
                79
            ],
            [
                50,
                70
            ],
            [
                60,
                65
            ],
            [
                70,
                59
            ],
            [
                80,
                52
            ],
            [
                90,
                45
            ],
            [
                100,
                42
            ]
        ]);
        defineColor('pink', [
            282,
            334
        ], [
            [
                20,
                100
            ],
            [
                30,
                90
            ],
            [
                40,
                86
            ],
            [
                60,
                84
            ],
            [
                80,
                80
            ],
            [
                90,
                75
            ],
            [
                100,
                73
            ]
        ]);
    }
    function HSVtoRGB(hsv) {
        // this doesn't work for the values of 0 and 360
        // here's the hacky fix
        var h = hsv[0];
        if (h === 0) h = 1;
        if (h === 360) h = 359;
        // Rebase the h,s,v values
        h = h / 360;
        var s = hsv[1] / 100, v = hsv[2] / 100;
        var h_i = Math.floor(h * 6), f = h * 6 - h_i, p = v * (1 - s), q = v * (1 - f * s), t = v * (1 - (1 - f) * s), r = 256, g = 256, b = 256;
        switch(h_i){
            case 0:
                r = v;
                g = t;
                b = p;
                break;
            case 1:
                r = q;
                g = v;
                b = p;
                break;
            case 2:
                r = p;
                g = v;
                b = t;
                break;
            case 3:
                r = p;
                g = q;
                b = v;
                break;
            case 4:
                r = t;
                g = p;
                b = v;
                break;
            case 5:
                r = v;
                g = p;
                b = q;
                break;
        }
        var result = [
            Math.floor(r * 255),
            Math.floor(g * 255),
            Math.floor(b * 255)
        ];
        return result;
    }
    function HexToHSB(hex) {
        hex = hex.replace(/^#/, '');
        hex = hex.length === 3 ? hex.replace(/(.)/g, '$1$1') : hex;
        var red = parseInt(hex.substr(0, 2), 16) / 255, green = parseInt(hex.substr(2, 2), 16) / 255, blue = parseInt(hex.substr(4, 2), 16) / 255;
        var cMax = Math.max(red, green, blue), delta = cMax - Math.min(red, green, blue), saturation = cMax ? delta / cMax : 0;
        switch(cMax){
            case red:
                return [
                    60 * ((green - blue) / delta % 6) || 0,
                    saturation,
                    cMax
                ];
            case green:
                return [
                    60 * ((blue - red) / delta + 2) || 0,
                    saturation,
                    cMax
                ];
            case blue:
                return [
                    60 * ((red - green) / delta + 4) || 0,
                    saturation,
                    cMax
                ];
        }
    }
    function HSVtoHSL(hsv) {
        var h = hsv[0], s = hsv[1] / 100, v = hsv[2] / 100, k = (2 - s) * v;
        return [
            h,
            Math.round(s * v / (k < 1 ? k : 2 - k) * 10000) / 100,
            k / 2 * 100
        ];
    }
    function stringToInteger(string) {
        var total = 0;
        for(var i = 0; i !== string.length; i++){
            if (total >= Number.MAX_SAFE_INTEGER) break;
            total += string.charCodeAt(i);
        }
        return total;
    }
    // get The range of given hue when options.count!=0
    function getRealHueRange(colorHue) {
        if (!isNaN(colorHue)) {
            var number = parseInt(colorHue);
            if (number < 360 && number > 0) return getColorInfo(colorHue).hueRange;
        } else if (typeof colorHue === 'string') {
            if (colorDictionary[colorHue]) {
                var color = colorDictionary[colorHue];
                if (color.hueRange) return color.hueRange;
            } else if (colorHue.match(/^#?([0-9A-F]{3}|[0-9A-F]{6})$/i)) {
                var hue = HexToHSB(colorHue)[0];
                return getColorInfo(hue).hueRange;
            }
        }
        return [
            0,
            360
        ];
    }
    return randomColor;
});

});


var $fjfo2 = parcelRequire("fjfo2");

var $a5cdb2d1e654e868$export$2e2bcd8739ae039 = (x, low = 0, high = 1)=>{
    return (0, $b055b672fea31fe3$export$96ec731ed4dcb222)((0, $b055b672fea31fe3$export$8960430cfd85939f)(low, x), high);
};


var $dacfc2a564661593$export$2e2bcd8739ae039 = (rgb)=>{
    rgb._clipped = false;
    rgb._unclipped = rgb.slice(0);
    for(let i = 0; i <= 3; i++){
        if (i < 3) {
            if (rgb[i] < 0 || rgb[i] > 255) rgb._clipped = true;
            rgb[i] = (0, $a5cdb2d1e654e868$export$2e2bcd8739ae039)(rgb[i], 0, 255);
        } else if (i === 3) rgb[i] = (0, $a5cdb2d1e654e868$export$2e2bcd8739ae039)(rgb[i], 0, 1);
    }
    return rgb;
};



// ported from jQuery's $.type
const $052f087f906e983c$var$classToType = {};
for (let name of [
    'Boolean',
    'Number',
    'String',
    'Function',
    'Array',
    'Date',
    'RegExp',
    'Undefined',
    'Null'
])$052f087f906e983c$var$classToType[`[object ${name}]`] = name.toLowerCase();
function $052f087f906e983c$export$2e2bcd8739ae039(obj) {
    return $052f087f906e983c$var$classToType[Object.prototype.toString.call(obj)] || 'object';
}



var $4e4c67bc5c6fc98d$export$2e2bcd8739ae039 = (args, keyOrder = null)=>{
    // if called with more than 3 arguments, we return the arguments
    if (args.length >= 3) return Array.prototype.slice.call(args);
    // with less than 3 args we check if first arg is object
    // and use the keyOrder string to extract and sort properties
    if ((0, $052f087f906e983c$export$2e2bcd8739ae039)(args[0]) == 'object' && keyOrder) return keyOrder.split('').filter((k)=>args[0][k] !== undefined).map((k)=>args[0][k]);
    // otherwise we just return the first argument
    // (which we suppose is an array of args)
    return args[0];
};



var $d6322d7f429dc557$export$2e2bcd8739ae039 = (args)=>{
    if (args.length < 2) return null;
    const l = args.length - 1;
    if ((0, $052f087f906e983c$export$2e2bcd8739ae039)(args[l]) == 'string') return args[l].toLowerCase();
    return null;
};


const { PI: $b055b672fea31fe3$export$6b5c1ceb16d01dc3, min: $b055b672fea31fe3$export$96ec731ed4dcb222, max: $b055b672fea31fe3$export$8960430cfd85939f } = Math;
const $b055b672fea31fe3$export$af54f71c879f5ba9 = $b055b672fea31fe3$export$6b5c1ceb16d01dc3 * 2;
const $b055b672fea31fe3$export$e734282486210baf = $b055b672fea31fe3$export$6b5c1ceb16d01dc3 / 3;
const $b055b672fea31fe3$export$460c4029b1a54a2e = $b055b672fea31fe3$export$6b5c1ceb16d01dc3 / 180;
const $b055b672fea31fe3$export$914076c8150813e5 = 180 / $b055b672fea31fe3$export$6b5c1ceb16d01dc3;


var $8f39e66366edca09$export$2e2bcd8739ae039 = {
    format: {},
    autodetect: []
};


class $73c73657cae9064a$var$Color {
    constructor(...args){
        const me = this;
        if ((0, $052f087f906e983c$export$2e2bcd8739ae039)(args[0]) === 'object' && args[0].constructor && args[0].constructor === this.constructor) // the argument is already a Color instance
        return args[0];
        // last argument could be the mode
        let mode = (0, $d6322d7f429dc557$export$2e2bcd8739ae039)(args);
        let autodetect = false;
        if (!mode) {
            autodetect = true;
            if (!(0, $8f39e66366edca09$export$2e2bcd8739ae039).sorted) {
                (0, $8f39e66366edca09$export$2e2bcd8739ae039).autodetect = (0, $8f39e66366edca09$export$2e2bcd8739ae039).autodetect.sort((a, b)=>b.p - a.p);
                (0, $8f39e66366edca09$export$2e2bcd8739ae039).sorted = true;
            }
            // auto-detect format
            for (let chk of (0, $8f39e66366edca09$export$2e2bcd8739ae039).autodetect){
                mode = chk.test(...args);
                if (mode) break;
            }
        }
        if ((0, $8f39e66366edca09$export$2e2bcd8739ae039).format[mode]) {
            const rgb = (0, $8f39e66366edca09$export$2e2bcd8739ae039).format[mode].apply(null, autodetect ? args : args.slice(0, -1));
            me._rgb = (0, $dacfc2a564661593$export$2e2bcd8739ae039)(rgb);
        } else throw new Error('unknown format: ' + args);
        // add alpha channel
        if (me._rgb.length === 3) me._rgb.push(1);
    }
    toString() {
        if ((0, $052f087f906e983c$export$2e2bcd8739ae039)(this.hex) == 'function') return this.hex();
        return `[${this._rgb.join(',')}]`;
    }
}
var $73c73657cae9064a$export$2e2bcd8739ae039 = $73c73657cae9064a$var$Color;


// this gets updated automatically
const $78f1b280cc33258d$export$83d89fbfd8236492 = '2.6.0';


const $311ec6bd16e186d1$var$chroma = (...args)=>{
    return new $311ec6bd16e186d1$var$chroma.Color(...args);
};
$311ec6bd16e186d1$var$chroma.Color = (0, $73c73657cae9064a$export$2e2bcd8739ae039);
$311ec6bd16e186d1$var$chroma.version = (0, $78f1b280cc33258d$export$83d89fbfd8236492);
var $311ec6bd16e186d1$export$2e2bcd8739ae039 = $311ec6bd16e186d1$var$chroma;







const $7dfb03700941e666$var$cmyk2rgb = (...args)=>{
    args = (0, $4e4c67bc5c6fc98d$export$2e2bcd8739ae039)(args, 'cmyk');
    const [c, m, y, k] = args;
    const alpha = args.length > 4 ? args[4] : 1;
    if (k === 1) return [
        0,
        0,
        0,
        alpha
    ];
    return [
        c >= 1 ? 0 : 255 * (1 - c) * (1 - k),
        m >= 1 ? 0 : 255 * (1 - m) * (1 - k),
        y >= 1 ? 0 : 255 * (1 - y) * (1 - k),
        alpha
    ];
};
var $7dfb03700941e666$export$2e2bcd8739ae039 = $7dfb03700941e666$var$cmyk2rgb;



const { max: $b7b466880dadc9b9$var$max } = Math;
const $b7b466880dadc9b9$var$rgb2cmyk = (...args)=>{
    let [r, g, b] = (0, $4e4c67bc5c6fc98d$export$2e2bcd8739ae039)(args, 'rgb');
    r = r / 255;
    g = g / 255;
    b = b / 255;
    const k = 1 - $b7b466880dadc9b9$var$max(r, $b7b466880dadc9b9$var$max(g, b));
    const f = k < 1 ? 1 / (1 - k) : 0;
    const c = (1 - r - k) * f;
    const m = (1 - g - k) * f;
    const y = (1 - b - k) * f;
    return [
        c,
        m,
        y,
        k
    ];
};
var $b7b466880dadc9b9$export$2e2bcd8739ae039 = $b7b466880dadc9b9$var$rgb2cmyk;


(0, $73c73657cae9064a$export$2e2bcd8739ae039).prototype.cmyk = function() {
    return (0, $b7b466880dadc9b9$export$2e2bcd8739ae039)(this._rgb);
};
(0, $311ec6bd16e186d1$export$2e2bcd8739ae039).cmyk = (...args)=>new (0, $73c73657cae9064a$export$2e2bcd8739ae039)(...args, 'cmyk');
(0, $8f39e66366edca09$export$2e2bcd8739ae039).format.cmyk = (0, $7dfb03700941e666$export$2e2bcd8739ae039);
(0, $8f39e66366edca09$export$2e2bcd8739ae039).autodetect.push({
    p: 2,
    test: (...args)=>{
        args = (0, $4e4c67bc5c6fc98d$export$2e2bcd8739ae039)(args, 'cmyk');
        if ((0, $052f087f906e983c$export$2e2bcd8739ae039)(args) === 'array' && args.length === 4) return 'cmyk';
    }
});








const $97625bbd65261d71$var$rnd = (a)=>Math.round(a * 100) / 100;
/*
 * supported arguments:
 * - hsl2css(h,s,l)
 * - hsl2css(h,s,l,a)
 * - hsl2css([h,s,l], mode)
 * - hsl2css([h,s,l,a], mode)
 * - hsl2css({h,s,l,a}, mode)
 */ const $97625bbd65261d71$var$hsl2css = (...args)=>{
    const hsla = (0, $4e4c67bc5c6fc98d$export$2e2bcd8739ae039)(args, 'hsla');
    let mode = (0, $d6322d7f429dc557$export$2e2bcd8739ae039)(args) || 'lsa';
    hsla[0] = $97625bbd65261d71$var$rnd(hsla[0] || 0);
    hsla[1] = $97625bbd65261d71$var$rnd(hsla[1] * 100) + '%';
    hsla[2] = $97625bbd65261d71$var$rnd(hsla[2] * 100) + '%';
    if (mode === 'hsla' || hsla.length > 3 && hsla[3] < 1) {
        hsla[3] = hsla.length > 3 ? hsla[3] : 1;
        mode = 'hsla';
    } else hsla.length = 3;
    return `${mode}(${hsla.join(',')})`;
};
var $97625bbd65261d71$export$2e2bcd8739ae039 = $97625bbd65261d71$var$hsl2css;



/*
 * supported arguments:
 * - rgb2hsl(r,g,b)
 * - rgb2hsl(r,g,b,a)
 * - rgb2hsl([r,g,b])
 * - rgb2hsl([r,g,b,a])
 * - rgb2hsl({r,g,b,a})
 */ const $ca73c6d9aefef096$var$rgb2hsl = (...args)=>{
    args = (0, $4e4c67bc5c6fc98d$export$2e2bcd8739ae039)(args, 'rgba');
    let [r, g, b] = args;
    r /= 255;
    g /= 255;
    b /= 255;
    const minRgb = (0, $b055b672fea31fe3$export$96ec731ed4dcb222)(r, g, b);
    const maxRgb = (0, $b055b672fea31fe3$export$8960430cfd85939f)(r, g, b);
    const l = (maxRgb + minRgb) / 2;
    let s, h;
    if (maxRgb === minRgb) {
        s = 0;
        h = Number.NaN;
    } else s = l < 0.5 ? (maxRgb - minRgb) / (maxRgb + minRgb) : (maxRgb - minRgb) / (2 - maxRgb - minRgb);
    if (r == maxRgb) h = (g - b) / (maxRgb - minRgb);
    else if (g == maxRgb) h = 2 + (b - r) / (maxRgb - minRgb);
    else if (b == maxRgb) h = 4 + (r - g) / (maxRgb - minRgb);
    h *= 60;
    if (h < 0) h += 360;
    if (args.length > 3 && args[3] !== undefined) return [
        h,
        s,
        l,
        args[3]
    ];
    return [
        h,
        s,
        l
    ];
};
var $ca73c6d9aefef096$export$2e2bcd8739ae039 = $ca73c6d9aefef096$var$rgb2hsl;


const { round: $d0b1d1770a7ce4b5$var$round } = Math;
/*
 * supported arguments:
 * - rgb2css(r,g,b)
 * - rgb2css(r,g,b,a)
 * - rgb2css([r,g,b], mode)
 * - rgb2css([r,g,b,a], mode)
 * - rgb2css({r,g,b,a}, mode)
 */ const $d0b1d1770a7ce4b5$var$rgb2css = (...args)=>{
    const rgba = (0, $4e4c67bc5c6fc98d$export$2e2bcd8739ae039)(args, 'rgba');
    let mode = (0, $d6322d7f429dc557$export$2e2bcd8739ae039)(args) || 'rgb';
    if (mode.substr(0, 3) == 'hsl') return (0, $97625bbd65261d71$export$2e2bcd8739ae039)((0, $ca73c6d9aefef096$export$2e2bcd8739ae039)(rgba), mode);
    rgba[0] = $d0b1d1770a7ce4b5$var$round(rgba[0]);
    rgba[1] = $d0b1d1770a7ce4b5$var$round(rgba[1]);
    rgba[2] = $d0b1d1770a7ce4b5$var$round(rgba[2]);
    if (mode === 'rgba' || rgba.length > 3 && rgba[3] < 1) {
        rgba[3] = rgba.length > 3 ? rgba[3] : 1;
        mode = 'rgba';
    }
    return `${mode}(${rgba.slice(0, mode === 'rgb' ? 3 : 4).join(',')})`;
};
var $d0b1d1770a7ce4b5$export$2e2bcd8739ae039 = $d0b1d1770a7ce4b5$var$rgb2css;



const { round: $9afc3e3640e20219$var$round } = Math;
const $9afc3e3640e20219$var$hsl2rgb = (...args)=>{
    args = (0, $4e4c67bc5c6fc98d$export$2e2bcd8739ae039)(args, 'hsl');
    const [h, s, l] = args;
    let r, g, b;
    if (s === 0) r = g = b = l * 255;
    else {
        const t3 = [
            0,
            0,
            0
        ];
        const c = [
            0,
            0,
            0
        ];
        const t2 = l < 0.5 ? l * (1 + s) : l + s - l * s;
        const t1 = 2 * l - t2;
        const h_ = h / 360;
        t3[0] = h_ + 1 / 3;
        t3[1] = h_;
        t3[2] = h_ - 1 / 3;
        for(let i = 0; i < 3; i++){
            if (t3[i] < 0) t3[i] += 1;
            if (t3[i] > 1) t3[i] -= 1;
            if (6 * t3[i] < 1) c[i] = t1 + (t2 - t1) * 6 * t3[i];
            else if (2 * t3[i] < 1) c[i] = t2;
            else if (3 * t3[i] < 2) c[i] = t1 + (t2 - t1) * (2 / 3 - t3[i]) * 6;
            else c[i] = t1;
        }
        [r, g, b] = [
            $9afc3e3640e20219$var$round(c[0] * 255),
            $9afc3e3640e20219$var$round(c[1] * 255),
            $9afc3e3640e20219$var$round(c[2] * 255)
        ];
    }
    if (args.length > 3) // keep alpha channel
    return [
        r,
        g,
        b,
        args[3]
    ];
    return [
        r,
        g,
        b,
        1
    ];
};
var $9afc3e3640e20219$export$2e2bcd8739ae039 = $9afc3e3640e20219$var$hsl2rgb;



const $ca1722ef8b79b00e$var$RE_RGB = /^rgb\(\s*(-?\d+),\s*(-?\d+)\s*,\s*(-?\d+)\s*\)$/;
const $ca1722ef8b79b00e$var$RE_RGBA = /^rgba\(\s*(-?\d+),\s*(-?\d+)\s*,\s*(-?\d+)\s*,\s*([01]|[01]?\.\d+)\)$/;
const $ca1722ef8b79b00e$var$RE_RGB_PCT = /^rgb\(\s*(-?\d+(?:\.\d+)?)%,\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*\)$/;
const $ca1722ef8b79b00e$var$RE_RGBA_PCT = /^rgba\(\s*(-?\d+(?:\.\d+)?)%,\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*,\s*([01]|[01]?\.\d+)\)$/;
const $ca1722ef8b79b00e$var$RE_HSL = /^hsl\(\s*(-?\d+(?:\.\d+)?),\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*\)$/;
const $ca1722ef8b79b00e$var$RE_HSLA = /^hsla\(\s*(-?\d+(?:\.\d+)?),\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*,\s*([01]|[01]?\.\d+)\)$/;
const { round: $ca1722ef8b79b00e$var$round } = Math;
const $ca1722ef8b79b00e$var$css2rgb = (css)=>{
    css = css.toLowerCase().trim();
    let m;
    if ((0, $8f39e66366edca09$export$2e2bcd8739ae039).format.named) try {
        return (0, $8f39e66366edca09$export$2e2bcd8739ae039).format.named(css);
    // eslint-disable-next-line
    } catch (e) {}
    // rgb(250,20,0)
    if (m = css.match($ca1722ef8b79b00e$var$RE_RGB)) {
        const rgb = m.slice(1, 4);
        for(let i = 0; i < 3; i++)rgb[i] = +rgb[i];
        rgb[3] = 1; // default alpha
        return rgb;
    }
    // rgba(250,20,0,0.4)
    if (m = css.match($ca1722ef8b79b00e$var$RE_RGBA)) {
        const rgb = m.slice(1, 5);
        for(let i = 0; i < 4; i++)rgb[i] = +rgb[i];
        return rgb;
    }
    // rgb(100%,0%,0%)
    if (m = css.match($ca1722ef8b79b00e$var$RE_RGB_PCT)) {
        const rgb = m.slice(1, 4);
        for(let i = 0; i < 3; i++)rgb[i] = $ca1722ef8b79b00e$var$round(rgb[i] * 2.55);
        rgb[3] = 1; // default alpha
        return rgb;
    }
    // rgba(100%,0%,0%,0.4)
    if (m = css.match($ca1722ef8b79b00e$var$RE_RGBA_PCT)) {
        const rgb = m.slice(1, 5);
        for(let i = 0; i < 3; i++)rgb[i] = $ca1722ef8b79b00e$var$round(rgb[i] * 2.55);
        rgb[3] = +rgb[3];
        return rgb;
    }
    // hsl(0,100%,50%)
    if (m = css.match($ca1722ef8b79b00e$var$RE_HSL)) {
        const hsl = m.slice(1, 4);
        hsl[1] *= 0.01;
        hsl[2] *= 0.01;
        const rgb = (0, $9afc3e3640e20219$export$2e2bcd8739ae039)(hsl);
        rgb[3] = 1;
        return rgb;
    }
    // hsla(0,100%,50%,0.5)
    if (m = css.match($ca1722ef8b79b00e$var$RE_HSLA)) {
        const hsl = m.slice(1, 4);
        hsl[1] *= 0.01;
        hsl[2] *= 0.01;
        const rgb = (0, $9afc3e3640e20219$export$2e2bcd8739ae039)(hsl);
        rgb[3] = +m[4]; // default alpha = 1
        return rgb;
    }
};
$ca1722ef8b79b00e$var$css2rgb.test = (s)=>{
    return $ca1722ef8b79b00e$var$RE_RGB.test(s) || $ca1722ef8b79b00e$var$RE_RGBA.test(s) || $ca1722ef8b79b00e$var$RE_RGB_PCT.test(s) || $ca1722ef8b79b00e$var$RE_RGBA_PCT.test(s) || $ca1722ef8b79b00e$var$RE_HSL.test(s) || $ca1722ef8b79b00e$var$RE_HSLA.test(s);
};
var $ca1722ef8b79b00e$export$2e2bcd8739ae039 = $ca1722ef8b79b00e$var$css2rgb;


(0, $73c73657cae9064a$export$2e2bcd8739ae039).prototype.css = function(mode) {
    return (0, $d0b1d1770a7ce4b5$export$2e2bcd8739ae039)(this._rgb, mode);
};
(0, $311ec6bd16e186d1$export$2e2bcd8739ae039).css = (...args)=>new (0, $73c73657cae9064a$export$2e2bcd8739ae039)(...args, 'css');
(0, $8f39e66366edca09$export$2e2bcd8739ae039).format.css = (0, $ca1722ef8b79b00e$export$2e2bcd8739ae039);
(0, $8f39e66366edca09$export$2e2bcd8739ae039).autodetect.push({
    p: 5,
    test: (h, ...rest)=>{
        if (!rest.length && (0, $052f087f906e983c$export$2e2bcd8739ae039)(h) === 'string' && (0, $ca1722ef8b79b00e$export$2e2bcd8739ae039).test(h)) return 'css';
    }
});






(0, $8f39e66366edca09$export$2e2bcd8739ae039).format.gl = (...args)=>{
    const rgb = (0, $4e4c67bc5c6fc98d$export$2e2bcd8739ae039)(args, 'rgba');
    rgb[0] *= 255;
    rgb[1] *= 255;
    rgb[2] *= 255;
    return rgb;
};
(0, $311ec6bd16e186d1$export$2e2bcd8739ae039).gl = (...args)=>new (0, $73c73657cae9064a$export$2e2bcd8739ae039)(...args, 'gl');
(0, $73c73657cae9064a$export$2e2bcd8739ae039).prototype.gl = function() {
    const rgb = this._rgb;
    return [
        rgb[0] / 255,
        rgb[1] / 255,
        rgb[2] / 255,
        rgb[3]
    ];
};







const { floor: $7d17c930c3b94a45$var$floor } = Math;
/*
 * this is basically just HSV with some minor tweaks
 *
 * hue.. [0..360]
 * chroma .. [0..1]
 * grayness .. [0..1]
 */ const $7d17c930c3b94a45$var$hcg2rgb = (...args)=>{
    args = (0, $4e4c67bc5c6fc98d$export$2e2bcd8739ae039)(args, 'hcg');
    let [h, c, _g] = args;
    let r, g, b;
    _g = _g * 255;
    const _c = c * 255;
    if (c === 0) r = g = b = _g;
    else {
        if (h === 360) h = 0;
        if (h > 360) h -= 360;
        if (h < 0) h += 360;
        h /= 60;
        const i = $7d17c930c3b94a45$var$floor(h);
        const f = h - i;
        const p = _g * (1 - c);
        const q = p + _c * (1 - f);
        const t = p + _c * f;
        const v = p + _c;
        switch(i){
            case 0:
                [r, g, b] = [
                    v,
                    t,
                    p
                ];
                break;
            case 1:
                [r, g, b] = [
                    q,
                    v,
                    p
                ];
                break;
            case 2:
                [r, g, b] = [
                    p,
                    v,
                    t
                ];
                break;
            case 3:
                [r, g, b] = [
                    p,
                    q,
                    v
                ];
                break;
            case 4:
                [r, g, b] = [
                    t,
                    p,
                    v
                ];
                break;
            case 5:
                [r, g, b] = [
                    v,
                    p,
                    q
                ];
                break;
        }
    }
    return [
        r,
        g,
        b,
        args.length > 3 ? args[3] : 1
    ];
};
var $7d17c930c3b94a45$export$2e2bcd8739ae039 = $7d17c930c3b94a45$var$hcg2rgb;



const $4fb93a884ae2da29$var$rgb2hcg = (...args)=>{
    const [r, g, b] = (0, $4e4c67bc5c6fc98d$export$2e2bcd8739ae039)(args, 'rgb');
    const minRgb = (0, $b055b672fea31fe3$export$96ec731ed4dcb222)(r, g, b);
    const maxRgb = (0, $b055b672fea31fe3$export$8960430cfd85939f)(r, g, b);
    const delta = maxRgb - minRgb;
    const c = delta * 100 / 255;
    const _g = minRgb / (255 - delta) * 100;
    let h;
    if (delta === 0) h = Number.NaN;
    else {
        if (r === maxRgb) h = (g - b) / delta;
        if (g === maxRgb) h = 2 + (b - r) / delta;
        if (b === maxRgb) h = 4 + (r - g) / delta;
        h *= 60;
        if (h < 0) h += 360;
    }
    return [
        h,
        c,
        _g
    ];
};
var $4fb93a884ae2da29$export$2e2bcd8739ae039 = $4fb93a884ae2da29$var$rgb2hcg;


(0, $73c73657cae9064a$export$2e2bcd8739ae039).prototype.hcg = function() {
    return (0, $4fb93a884ae2da29$export$2e2bcd8739ae039)(this._rgb);
};
(0, $311ec6bd16e186d1$export$2e2bcd8739ae039).hcg = (...args)=>new (0, $73c73657cae9064a$export$2e2bcd8739ae039)(...args, 'hcg');
(0, $8f39e66366edca09$export$2e2bcd8739ae039).format.hcg = (0, $7d17c930c3b94a45$export$2e2bcd8739ae039);
(0, $8f39e66366edca09$export$2e2bcd8739ae039).autodetect.push({
    p: 1,
    test: (...args)=>{
        args = (0, $4e4c67bc5c6fc98d$export$2e2bcd8739ae039)(args, 'hcg');
        if ((0, $052f087f906e983c$export$2e2bcd8739ae039)(args) === 'array' && args.length === 3) return 'hcg';
    }
});






const $09d0f38f74bc928e$var$RE_HEX = /^#?([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
const $09d0f38f74bc928e$var$RE_HEXA = /^#?([A-Fa-f0-9]{8}|[A-Fa-f0-9]{4})$/;
const $09d0f38f74bc928e$var$hex2rgb = (hex)=>{
    if (hex.match($09d0f38f74bc928e$var$RE_HEX)) {
        // remove optional leading #
        if (hex.length === 4 || hex.length === 7) hex = hex.substr(1);
        // expand short-notation to full six-digit
        if (hex.length === 3) {
            hex = hex.split('');
            hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
        }
        const u = parseInt(hex, 16);
        const r = u >> 16;
        const g = u >> 8 & 0xff;
        const b = u & 0xff;
        return [
            r,
            g,
            b,
            1
        ];
    }
    // match rgba hex format, eg #FF000077
    if (hex.match($09d0f38f74bc928e$var$RE_HEXA)) {
        if (hex.length === 5 || hex.length === 9) // remove optional leading #
        hex = hex.substr(1);
        // expand short-notation to full eight-digit
        if (hex.length === 4) {
            hex = hex.split('');
            hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2] + hex[3] + hex[3];
        }
        const u = parseInt(hex, 16);
        const r = u >> 24 & 0xff;
        const g = u >> 16 & 0xff;
        const b = u >> 8 & 0xff;
        const a = Math.round((u & 0xff) / 0xff * 100) / 100;
        return [
            r,
            g,
            b,
            a
        ];
    }
    // we used to check for css colors here
    // if _input.css? and rgb = _input.css hex
    //     return rgb
    throw new Error(`unknown hex color: ${hex}`);
};
var $09d0f38f74bc928e$export$2e2bcd8739ae039 = $09d0f38f74bc928e$var$hex2rgb;



const { round: $aca12e9f2920fd69$var$round } = Math;
const $aca12e9f2920fd69$var$rgb2hex = (...args)=>{
    let [r, g, b, a] = (0, $4e4c67bc5c6fc98d$export$2e2bcd8739ae039)(args, 'rgba');
    let mode = (0, $d6322d7f429dc557$export$2e2bcd8739ae039)(args) || 'auto';
    if (a === undefined) a = 1;
    if (mode === 'auto') mode = a < 1 ? 'rgba' : 'rgb';
    r = $aca12e9f2920fd69$var$round(r);
    g = $aca12e9f2920fd69$var$round(g);
    b = $aca12e9f2920fd69$var$round(b);
    const u = r << 16 | g << 8 | b;
    let str = '000000' + u.toString(16); //#.toUpperCase();
    str = str.substr(str.length - 6);
    let hxa = '0' + $aca12e9f2920fd69$var$round(a * 255).toString(16);
    hxa = hxa.substr(hxa.length - 2);
    switch(mode.toLowerCase()){
        case 'rgba':
            return `#${str}${hxa}`;
        case 'argb':
            return `#${hxa}${str}`;
        default:
            return `#${str}`;
    }
};
var $aca12e9f2920fd69$export$2e2bcd8739ae039 = $aca12e9f2920fd69$var$rgb2hex;


(0, $73c73657cae9064a$export$2e2bcd8739ae039).prototype.hex = function(mode) {
    return (0, $aca12e9f2920fd69$export$2e2bcd8739ae039)(this._rgb, mode);
};
(0, $311ec6bd16e186d1$export$2e2bcd8739ae039).hex = (...args)=>new (0, $73c73657cae9064a$export$2e2bcd8739ae039)(...args, 'hex');
(0, $8f39e66366edca09$export$2e2bcd8739ae039).format.hex = (0, $09d0f38f74bc928e$export$2e2bcd8739ae039);
(0, $8f39e66366edca09$export$2e2bcd8739ae039).autodetect.push({
    p: 4,
    test: (h, ...rest)=>{
        if (!rest.length && (0, $052f087f906e983c$export$2e2bcd8739ae039)(h) === 'string' && [
            3,
            4,
            5,
            6,
            7,
            8,
            9
        ].indexOf(h.length) >= 0) return 'hex';
    }
});







const { cos: $6b6cf761bdd88f2b$var$cos } = Math;
/*
 * hue [0..360]
 * saturation [0..1]
 * intensity [0..1]
 */ const $6b6cf761bdd88f2b$var$hsi2rgb = (...args)=>{
    /*
    borrowed from here:
    http://hummer.stanford.edu/museinfo/doc/examples/humdrum/keyscape2/hsi2rgb.cpp
    */ args = (0, $4e4c67bc5c6fc98d$export$2e2bcd8739ae039)(args, 'hsi');
    let [h, s, i] = args;
    let r, g, b;
    if (isNaN(h)) h = 0;
    if (isNaN(s)) s = 0;
    // normalize hue
    if (h > 360) h -= 360;
    if (h < 0) h += 360;
    h /= 360;
    if (h < 1 / 3) {
        b = (1 - s) / 3;
        r = (1 + s * $6b6cf761bdd88f2b$var$cos((0, $b055b672fea31fe3$export$af54f71c879f5ba9) * h) / $6b6cf761bdd88f2b$var$cos((0, $b055b672fea31fe3$export$e734282486210baf) - (0, $b055b672fea31fe3$export$af54f71c879f5ba9) * h)) / 3;
        g = 1 - (b + r);
    } else if (h < 2 / 3) {
        h -= 1 / 3;
        r = (1 - s) / 3;
        g = (1 + s * $6b6cf761bdd88f2b$var$cos((0, $b055b672fea31fe3$export$af54f71c879f5ba9) * h) / $6b6cf761bdd88f2b$var$cos((0, $b055b672fea31fe3$export$e734282486210baf) - (0, $b055b672fea31fe3$export$af54f71c879f5ba9) * h)) / 3;
        b = 1 - (r + g);
    } else {
        h -= 2 / 3;
        g = (1 - s) / 3;
        b = (1 + s * $6b6cf761bdd88f2b$var$cos((0, $b055b672fea31fe3$export$af54f71c879f5ba9) * h) / $6b6cf761bdd88f2b$var$cos((0, $b055b672fea31fe3$export$e734282486210baf) - (0, $b055b672fea31fe3$export$af54f71c879f5ba9) * h)) / 3;
        r = 1 - (g + b);
    }
    r = (0, $a5cdb2d1e654e868$export$2e2bcd8739ae039)(i * r * 3);
    g = (0, $a5cdb2d1e654e868$export$2e2bcd8739ae039)(i * g * 3);
    b = (0, $a5cdb2d1e654e868$export$2e2bcd8739ae039)(i * b * 3);
    return [
        r * 255,
        g * 255,
        b * 255,
        args.length > 3 ? args[3] : 1
    ];
};
var $6b6cf761bdd88f2b$export$2e2bcd8739ae039 = $6b6cf761bdd88f2b$var$hsi2rgb;



const { min: $4d0bc2235b63ccfe$var$min, sqrt: $4d0bc2235b63ccfe$var$sqrt, acos: $4d0bc2235b63ccfe$var$acos } = Math;
const $4d0bc2235b63ccfe$var$rgb2hsi = (...args)=>{
    /*
    borrowed from here:
    http://hummer.stanford.edu/museinfo/doc/examples/humdrum/keyscape2/rgb2hsi.cpp
    */ let [r, g, b] = (0, $4e4c67bc5c6fc98d$export$2e2bcd8739ae039)(args, 'rgb');
    r /= 255;
    g /= 255;
    b /= 255;
    let h;
    const min_ = $4d0bc2235b63ccfe$var$min(r, g, b);
    const i = (r + g + b) / 3;
    const s = i > 0 ? 1 - min_ / i : 0;
    if (s === 0) h = NaN;
    else {
        h = (r - g + (r - b)) / 2;
        h /= $4d0bc2235b63ccfe$var$sqrt((r - g) * (r - g) + (r - b) * (g - b));
        h = $4d0bc2235b63ccfe$var$acos(h);
        if (b > g) h = (0, $b055b672fea31fe3$export$af54f71c879f5ba9) - h;
        h /= (0, $b055b672fea31fe3$export$af54f71c879f5ba9);
    }
    return [
        h * 360,
        s,
        i
    ];
};
var $4d0bc2235b63ccfe$export$2e2bcd8739ae039 = $4d0bc2235b63ccfe$var$rgb2hsi;


(0, $73c73657cae9064a$export$2e2bcd8739ae039).prototype.hsi = function() {
    return (0, $4d0bc2235b63ccfe$export$2e2bcd8739ae039)(this._rgb);
};
(0, $311ec6bd16e186d1$export$2e2bcd8739ae039).hsi = (...args)=>new (0, $73c73657cae9064a$export$2e2bcd8739ae039)(...args, 'hsi');
(0, $8f39e66366edca09$export$2e2bcd8739ae039).format.hsi = (0, $6b6cf761bdd88f2b$export$2e2bcd8739ae039);
(0, $8f39e66366edca09$export$2e2bcd8739ae039).autodetect.push({
    p: 2,
    test: (...args)=>{
        args = (0, $4e4c67bc5c6fc98d$export$2e2bcd8739ae039)(args, 'hsi');
        if ((0, $052f087f906e983c$export$2e2bcd8739ae039)(args) === 'array' && args.length === 3) return 'hsi';
    }
});








(0, $73c73657cae9064a$export$2e2bcd8739ae039).prototype.hsl = function() {
    return (0, $ca73c6d9aefef096$export$2e2bcd8739ae039)(this._rgb);
};
(0, $311ec6bd16e186d1$export$2e2bcd8739ae039).hsl = (...args)=>new (0, $73c73657cae9064a$export$2e2bcd8739ae039)(...args, 'hsl');
(0, $8f39e66366edca09$export$2e2bcd8739ae039).format.hsl = (0, $9afc3e3640e20219$export$2e2bcd8739ae039);
(0, $8f39e66366edca09$export$2e2bcd8739ae039).autodetect.push({
    p: 2,
    test: (...args)=>{
        args = (0, $4e4c67bc5c6fc98d$export$2e2bcd8739ae039)(args, 'hsl');
        if ((0, $052f087f906e983c$export$2e2bcd8739ae039)(args) === 'array' && args.length === 3) return 'hsl';
    }
});







const { floor: $ac3199f94bdda45d$var$floor } = Math;
const $ac3199f94bdda45d$var$hsv2rgb = (...args)=>{
    args = (0, $4e4c67bc5c6fc98d$export$2e2bcd8739ae039)(args, 'hsv');
    let [h, s, v] = args;
    let r, g, b;
    v *= 255;
    if (s === 0) r = g = b = v;
    else {
        if (h === 360) h = 0;
        if (h > 360) h -= 360;
        if (h < 0) h += 360;
        h /= 60;
        const i = $ac3199f94bdda45d$var$floor(h);
        const f = h - i;
        const p = v * (1 - s);
        const q = v * (1 - s * f);
        const t = v * (1 - s * (1 - f));
        switch(i){
            case 0:
                [r, g, b] = [
                    v,
                    t,
                    p
                ];
                break;
            case 1:
                [r, g, b] = [
                    q,
                    v,
                    p
                ];
                break;
            case 2:
                [r, g, b] = [
                    p,
                    v,
                    t
                ];
                break;
            case 3:
                [r, g, b] = [
                    p,
                    q,
                    v
                ];
                break;
            case 4:
                [r, g, b] = [
                    t,
                    p,
                    v
                ];
                break;
            case 5:
                [r, g, b] = [
                    v,
                    p,
                    q
                ];
                break;
        }
    }
    return [
        r,
        g,
        b,
        args.length > 3 ? args[3] : 1
    ];
};
var $ac3199f94bdda45d$export$2e2bcd8739ae039 = $ac3199f94bdda45d$var$hsv2rgb;



const { min: $896ab0507911ba53$var$min, max: $896ab0507911ba53$var$max } = Math;
/*
 * supported arguments:
 * - rgb2hsv(r,g,b)
 * - rgb2hsv([r,g,b])
 * - rgb2hsv({r,g,b})
 */ const $896ab0507911ba53$var$rgb2hsl = (...args)=>{
    args = (0, $4e4c67bc5c6fc98d$export$2e2bcd8739ae039)(args, 'rgb');
    let [r, g, b] = args;
    const min_ = $896ab0507911ba53$var$min(r, g, b);
    const max_ = $896ab0507911ba53$var$max(r, g, b);
    const delta = max_ - min_;
    let h, s, v;
    v = max_ / 255.0;
    if (max_ === 0) {
        h = Number.NaN;
        s = 0;
    } else {
        s = delta / max_;
        if (r === max_) h = (g - b) / delta;
        if (g === max_) h = 2 + (b - r) / delta;
        if (b === max_) h = 4 + (r - g) / delta;
        h *= 60;
        if (h < 0) h += 360;
    }
    return [
        h,
        s,
        v
    ];
};
var $896ab0507911ba53$export$2e2bcd8739ae039 = $896ab0507911ba53$var$rgb2hsl;


(0, $73c73657cae9064a$export$2e2bcd8739ae039).prototype.hsv = function() {
    return (0, $896ab0507911ba53$export$2e2bcd8739ae039)(this._rgb);
};
(0, $311ec6bd16e186d1$export$2e2bcd8739ae039).hsv = (...args)=>new (0, $73c73657cae9064a$export$2e2bcd8739ae039)(...args, 'hsv');
(0, $8f39e66366edca09$export$2e2bcd8739ae039).format.hsv = (0, $ac3199f94bdda45d$export$2e2bcd8739ae039);
(0, $8f39e66366edca09$export$2e2bcd8739ae039).autodetect.push({
    p: 2,
    test: (...args)=>{
        args = (0, $4e4c67bc5c6fc98d$export$2e2bcd8739ae039)(args, 'hsv');
        if ((0, $052f087f906e983c$export$2e2bcd8739ae039)(args) === 'array' && args.length === 3) return 'hsv';
    }
});






var $e5e786d1c89b5967$export$2e2bcd8739ae039 = {
    // Corresponds roughly to RGB brighter/darker
    Kn: 18,
    // D65 standard referent
    Xn: 0.95047,
    Yn: 1,
    Zn: 1.08883,
    t0: 0.137931034,
    t1: 0.206896552,
    t2: 0.12841855,
    t3: 0.008856452 // t1 * t1 * t1
};



const { pow: $0e4e69d2086da257$var$pow } = Math;
/*
 * L* [0..100]
 * a [-100..100]
 * b [-100..100]
 */ const $0e4e69d2086da257$var$lab2rgb = (...args)=>{
    args = (0, $4e4c67bc5c6fc98d$export$2e2bcd8739ae039)(args, 'lab');
    const [l, a, b] = args;
    let x, y, z, r, g, b_;
    y = (l + 16) / 116;
    x = isNaN(a) ? y : y + a / 500;
    z = isNaN(b) ? y : y - b / 200;
    y = (0, $e5e786d1c89b5967$export$2e2bcd8739ae039).Yn * $0e4e69d2086da257$var$lab_xyz(y);
    x = (0, $e5e786d1c89b5967$export$2e2bcd8739ae039).Xn * $0e4e69d2086da257$var$lab_xyz(x);
    z = (0, $e5e786d1c89b5967$export$2e2bcd8739ae039).Zn * $0e4e69d2086da257$var$lab_xyz(z);
    r = $0e4e69d2086da257$var$xyz_rgb(3.2404542 * x - 1.5371385 * y - 0.4985314 * z); // D65 -> sRGB
    g = $0e4e69d2086da257$var$xyz_rgb(-0.969266 * x + 1.8760108 * y + 0.041556 * z);
    b_ = $0e4e69d2086da257$var$xyz_rgb(0.0556434 * x - 0.2040259 * y + 1.0572252 * z);
    return [
        r,
        g,
        b_,
        args.length > 3 ? args[3] : 1
    ];
};
const $0e4e69d2086da257$var$xyz_rgb = (r)=>{
    return 255 * (r <= 0.00304 ? 12.92 * r : 1.055 * $0e4e69d2086da257$var$pow(r, 1 / 2.4) - 0.055);
};
const $0e4e69d2086da257$var$lab_xyz = (t)=>{
    return t > (0, $e5e786d1c89b5967$export$2e2bcd8739ae039).t1 ? t * t * t : (0, $e5e786d1c89b5967$export$2e2bcd8739ae039).t2 * (t - (0, $e5e786d1c89b5967$export$2e2bcd8739ae039).t0);
};
var $0e4e69d2086da257$export$2e2bcd8739ae039 = $0e4e69d2086da257$var$lab2rgb;




const { pow: $759c3f48fe1d971b$var$pow } = Math;
const $759c3f48fe1d971b$var$rgb2lab = (...args)=>{
    const [r, g, b] = (0, $4e4c67bc5c6fc98d$export$2e2bcd8739ae039)(args, 'rgb');
    const [x, y, z] = $759c3f48fe1d971b$var$rgb2xyz(r, g, b);
    const l = 116 * y - 16;
    return [
        l < 0 ? 0 : l,
        500 * (x - y),
        200 * (y - z)
    ];
};
const $759c3f48fe1d971b$var$rgb_xyz = (r)=>{
    if ((r /= 255) <= 0.04045) return r / 12.92;
    return $759c3f48fe1d971b$var$pow((r + 0.055) / 1.055, 2.4);
};
const $759c3f48fe1d971b$var$xyz_lab = (t)=>{
    if (t > (0, $e5e786d1c89b5967$export$2e2bcd8739ae039).t3) return $759c3f48fe1d971b$var$pow(t, 1 / 3);
    return t / (0, $e5e786d1c89b5967$export$2e2bcd8739ae039).t2 + (0, $e5e786d1c89b5967$export$2e2bcd8739ae039).t0;
};
const $759c3f48fe1d971b$var$rgb2xyz = (r, g, b)=>{
    r = $759c3f48fe1d971b$var$rgb_xyz(r);
    g = $759c3f48fe1d971b$var$rgb_xyz(g);
    b = $759c3f48fe1d971b$var$rgb_xyz(b);
    const x = $759c3f48fe1d971b$var$xyz_lab((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / (0, $e5e786d1c89b5967$export$2e2bcd8739ae039).Xn);
    const y = $759c3f48fe1d971b$var$xyz_lab((0.2126729 * r + 0.7151522 * g + 0.072175 * b) / (0, $e5e786d1c89b5967$export$2e2bcd8739ae039).Yn);
    const z = $759c3f48fe1d971b$var$xyz_lab((0.0193339 * r + 0.119192 * g + 0.9503041 * b) / (0, $e5e786d1c89b5967$export$2e2bcd8739ae039).Zn);
    return [
        x,
        y,
        z
    ];
};
var $759c3f48fe1d971b$export$2e2bcd8739ae039 = $759c3f48fe1d971b$var$rgb2lab;


(0, $73c73657cae9064a$export$2e2bcd8739ae039).prototype.lab = function() {
    return (0, $759c3f48fe1d971b$export$2e2bcd8739ae039)(this._rgb);
};
(0, $311ec6bd16e186d1$export$2e2bcd8739ae039).lab = (...args)=>new (0, $73c73657cae9064a$export$2e2bcd8739ae039)(...args, 'lab');
(0, $8f39e66366edca09$export$2e2bcd8739ae039).format.lab = (0, $0e4e69d2086da257$export$2e2bcd8739ae039);
(0, $8f39e66366edca09$export$2e2bcd8739ae039).autodetect.push({
    p: 2,
    test: (...args)=>{
        args = (0, $4e4c67bc5c6fc98d$export$2e2bcd8739ae039)(args, 'lab');
        if ((0, $052f087f906e983c$export$2e2bcd8739ae039)(args) === 'array' && args.length === 3) return 'lab';
    }
});








const { sin: $11c384502518f696$var$sin, cos: $11c384502518f696$var$cos } = Math;
const $11c384502518f696$var$lch2lab = (...args)=>{
    /*
    Convert from a qualitative parameter h and a quantitative parameter l to a 24-bit pixel.
    These formulas were invented by David Dalrymple to obtain maximum contrast without going
    out of gamut if the parameters are in the range 0-1.

    A saturation multiplier was added by Gregor Aisch
    */ let [l, c, h] = (0, $4e4c67bc5c6fc98d$export$2e2bcd8739ae039)(args, 'lch');
    if (isNaN(h)) h = 0;
    h = h * (0, $b055b672fea31fe3$export$460c4029b1a54a2e);
    return [
        l,
        $11c384502518f696$var$cos(h) * c,
        $11c384502518f696$var$sin(h) * c
    ];
};
var $11c384502518f696$export$2e2bcd8739ae039 = $11c384502518f696$var$lch2lab;



const $820f558227d224dc$var$lch2rgb = (...args)=>{
    args = (0, $4e4c67bc5c6fc98d$export$2e2bcd8739ae039)(args, 'lch');
    const [l, c, h] = args;
    const [L, a, b_] = (0, $11c384502518f696$export$2e2bcd8739ae039)(l, c, h);
    const [r, g, b] = (0, $0e4e69d2086da257$export$2e2bcd8739ae039)(L, a, b_);
    return [
        r,
        g,
        b,
        args.length > 3 ? args[3] : 1
    ];
};
var $820f558227d224dc$export$2e2bcd8739ae039 = $820f558227d224dc$var$lch2rgb;




const $29e158ccbd1f7b12$var$hcl2rgb = (...args)=>{
    const hcl = (0, $4e4c67bc5c6fc98d$export$2e2bcd8739ae039)(args, 'hcl').reverse();
    return (0, $820f558227d224dc$export$2e2bcd8739ae039)(...hcl);
};
var $29e158ccbd1f7b12$export$2e2bcd8739ae039 = $29e158ccbd1f7b12$var$hcl2rgb;





const { sqrt: $dea01d9fa2b6ac43$var$sqrt, atan2: $dea01d9fa2b6ac43$var$atan2, round: $dea01d9fa2b6ac43$var$round } = Math;
const $dea01d9fa2b6ac43$var$lab2lch = (...args)=>{
    const [l, a, b] = (0, $4e4c67bc5c6fc98d$export$2e2bcd8739ae039)(args, 'lab');
    const c = $dea01d9fa2b6ac43$var$sqrt(a * a + b * b);
    let h = ($dea01d9fa2b6ac43$var$atan2(b, a) * (0, $b055b672fea31fe3$export$914076c8150813e5) + 360) % 360;
    if ($dea01d9fa2b6ac43$var$round(c * 10000) === 0) h = Number.NaN;
    return [
        l,
        c,
        h
    ];
};
var $dea01d9fa2b6ac43$export$2e2bcd8739ae039 = $dea01d9fa2b6ac43$var$lab2lch;


const $87cea72c5aad1be6$var$rgb2lch = (...args)=>{
    const [r, g, b] = (0, $4e4c67bc5c6fc98d$export$2e2bcd8739ae039)(args, 'rgb');
    const [l, a, b_] = (0, $759c3f48fe1d971b$export$2e2bcd8739ae039)(r, g, b);
    return (0, $dea01d9fa2b6ac43$export$2e2bcd8739ae039)(l, a, b_);
};
var $87cea72c5aad1be6$export$2e2bcd8739ae039 = $87cea72c5aad1be6$var$rgb2lch;


(0, $73c73657cae9064a$export$2e2bcd8739ae039).prototype.lch = function() {
    return (0, $87cea72c5aad1be6$export$2e2bcd8739ae039)(this._rgb);
};
(0, $73c73657cae9064a$export$2e2bcd8739ae039).prototype.hcl = function() {
    return (0, $87cea72c5aad1be6$export$2e2bcd8739ae039)(this._rgb).reverse();
};
(0, $311ec6bd16e186d1$export$2e2bcd8739ae039).lch = (...args)=>new (0, $73c73657cae9064a$export$2e2bcd8739ae039)(...args, 'lch');
(0, $311ec6bd16e186d1$export$2e2bcd8739ae039).hcl = (...args)=>new (0, $73c73657cae9064a$export$2e2bcd8739ae039)(...args, 'hcl');
(0, $8f39e66366edca09$export$2e2bcd8739ae039).format.lch = (0, $820f558227d224dc$export$2e2bcd8739ae039);
(0, $8f39e66366edca09$export$2e2bcd8739ae039).format.hcl = (0, $29e158ccbd1f7b12$export$2e2bcd8739ae039);
[
    'lch',
    'hcl'
].forEach((m)=>(0, $8f39e66366edca09$export$2e2bcd8739ae039).autodetect.push({
        p: 2,
        test: (...args)=>{
            args = (0, $4e4c67bc5c6fc98d$export$2e2bcd8739ae039)(args, m);
            if ((0, $052f087f906e983c$export$2e2bcd8739ae039)(args) === 'array' && args.length === 3) return m;
        }
    }));





/**
	X11 color names

	http://www.w3.org/TR/css3-color/#svg-color
*/ const $c5c068cfa2d42134$var$w3cx11 = {
    aliceblue: '#f0f8ff',
    antiquewhite: '#faebd7',
    aqua: '#00ffff',
    aquamarine: '#7fffd4',
    azure: '#f0ffff',
    beige: '#f5f5dc',
    bisque: '#ffe4c4',
    black: '#000000',
    blanchedalmond: '#ffebcd',
    blue: '#0000ff',
    blueviolet: '#8a2be2',
    brown: '#a52a2a',
    burlywood: '#deb887',
    cadetblue: '#5f9ea0',
    chartreuse: '#7fff00',
    chocolate: '#d2691e',
    coral: '#ff7f50',
    cornflowerblue: '#6495ed',
    cornsilk: '#fff8dc',
    crimson: '#dc143c',
    cyan: '#00ffff',
    darkblue: '#00008b',
    darkcyan: '#008b8b',
    darkgoldenrod: '#b8860b',
    darkgray: '#a9a9a9',
    darkgreen: '#006400',
    darkgrey: '#a9a9a9',
    darkkhaki: '#bdb76b',
    darkmagenta: '#8b008b',
    darkolivegreen: '#556b2f',
    darkorange: '#ff8c00',
    darkorchid: '#9932cc',
    darkred: '#8b0000',
    darksalmon: '#e9967a',
    darkseagreen: '#8fbc8f',
    darkslateblue: '#483d8b',
    darkslategray: '#2f4f4f',
    darkslategrey: '#2f4f4f',
    darkturquoise: '#00ced1',
    darkviolet: '#9400d3',
    deeppink: '#ff1493',
    deepskyblue: '#00bfff',
    dimgray: '#696969',
    dimgrey: '#696969',
    dodgerblue: '#1e90ff',
    firebrick: '#b22222',
    floralwhite: '#fffaf0',
    forestgreen: '#228b22',
    fuchsia: '#ff00ff',
    gainsboro: '#dcdcdc',
    ghostwhite: '#f8f8ff',
    gold: '#ffd700',
    goldenrod: '#daa520',
    gray: '#808080',
    green: '#008000',
    greenyellow: '#adff2f',
    grey: '#808080',
    honeydew: '#f0fff0',
    hotpink: '#ff69b4',
    indianred: '#cd5c5c',
    indigo: '#4b0082',
    ivory: '#fffff0',
    khaki: '#f0e68c',
    laserlemon: '#ffff54',
    lavender: '#e6e6fa',
    lavenderblush: '#fff0f5',
    lawngreen: '#7cfc00',
    lemonchiffon: '#fffacd',
    lightblue: '#add8e6',
    lightcoral: '#f08080',
    lightcyan: '#e0ffff',
    lightgoldenrod: '#fafad2',
    lightgoldenrodyellow: '#fafad2',
    lightgray: '#d3d3d3',
    lightgreen: '#90ee90',
    lightgrey: '#d3d3d3',
    lightpink: '#ffb6c1',
    lightsalmon: '#ffa07a',
    lightseagreen: '#20b2aa',
    lightskyblue: '#87cefa',
    lightslategray: '#778899',
    lightslategrey: '#778899',
    lightsteelblue: '#b0c4de',
    lightyellow: '#ffffe0',
    lime: '#00ff00',
    limegreen: '#32cd32',
    linen: '#faf0e6',
    magenta: '#ff00ff',
    maroon: '#800000',
    maroon2: '#7f0000',
    maroon3: '#b03060',
    mediumaquamarine: '#66cdaa',
    mediumblue: '#0000cd',
    mediumorchid: '#ba55d3',
    mediumpurple: '#9370db',
    mediumseagreen: '#3cb371',
    mediumslateblue: '#7b68ee',
    mediumspringgreen: '#00fa9a',
    mediumturquoise: '#48d1cc',
    mediumvioletred: '#c71585',
    midnightblue: '#191970',
    mintcream: '#f5fffa',
    mistyrose: '#ffe4e1',
    moccasin: '#ffe4b5',
    navajowhite: '#ffdead',
    navy: '#000080',
    oldlace: '#fdf5e6',
    olive: '#808000',
    olivedrab: '#6b8e23',
    orange: '#ffa500',
    orangered: '#ff4500',
    orchid: '#da70d6',
    palegoldenrod: '#eee8aa',
    palegreen: '#98fb98',
    paleturquoise: '#afeeee',
    palevioletred: '#db7093',
    papayawhip: '#ffefd5',
    peachpuff: '#ffdab9',
    peru: '#cd853f',
    pink: '#ffc0cb',
    plum: '#dda0dd',
    powderblue: '#b0e0e6',
    purple: '#800080',
    purple2: '#7f007f',
    purple3: '#a020f0',
    rebeccapurple: '#663399',
    red: '#ff0000',
    rosybrown: '#bc8f8f',
    royalblue: '#4169e1',
    saddlebrown: '#8b4513',
    salmon: '#fa8072',
    sandybrown: '#f4a460',
    seagreen: '#2e8b57',
    seashell: '#fff5ee',
    sienna: '#a0522d',
    silver: '#c0c0c0',
    skyblue: '#87ceeb',
    slateblue: '#6a5acd',
    slategray: '#708090',
    slategrey: '#708090',
    snow: '#fffafa',
    springgreen: '#00ff7f',
    steelblue: '#4682b4',
    tan: '#d2b48c',
    teal: '#008080',
    thistle: '#d8bfd8',
    tomato: '#ff6347',
    turquoise: '#40e0d0',
    violet: '#ee82ee',
    wheat: '#f5deb3',
    white: '#ffffff',
    whitesmoke: '#f5f5f5',
    yellow: '#ffff00',
    yellowgreen: '#9acd32'
};
var $c5c068cfa2d42134$export$2e2bcd8739ae039 = $c5c068cfa2d42134$var$w3cx11;




(0, $73c73657cae9064a$export$2e2bcd8739ae039).prototype.name = function() {
    const hex = (0, $aca12e9f2920fd69$export$2e2bcd8739ae039)(this._rgb, 'rgb');
    for (let n of Object.keys((0, $c5c068cfa2d42134$export$2e2bcd8739ae039))){
        if ((0, $c5c068cfa2d42134$export$2e2bcd8739ae039)[n] === hex) return n.toLowerCase();
    }
    return hex;
};
(0, $8f39e66366edca09$export$2e2bcd8739ae039).format.named = (name)=>{
    name = name.toLowerCase();
    if ((0, $c5c068cfa2d42134$export$2e2bcd8739ae039)[name]) return (0, $09d0f38f74bc928e$export$2e2bcd8739ae039)((0, $c5c068cfa2d42134$export$2e2bcd8739ae039)[name]);
    throw new Error('unknown color name: ' + name);
};
(0, $8f39e66366edca09$export$2e2bcd8739ae039).autodetect.push({
    p: 5,
    test: (h, ...rest)=>{
        if (!rest.length && (0, $052f087f906e983c$export$2e2bcd8739ae039)(h) === 'string' && (0, $c5c068cfa2d42134$export$2e2bcd8739ae039)[h.toLowerCase()]) return 'named';
    }
});







const $dcf3fedce6cf0351$var$num2rgb = (num)=>{
    if ((0, $052f087f906e983c$export$2e2bcd8739ae039)(num) == 'number' && num >= 0 && num <= 0xffffff) {
        const r = num >> 16;
        const g = num >> 8 & 0xff;
        const b = num & 0xff;
        return [
            r,
            g,
            b,
            1
        ];
    }
    throw new Error('unknown num color: ' + num);
};
var $dcf3fedce6cf0351$export$2e2bcd8739ae039 = $dcf3fedce6cf0351$var$num2rgb;



const $3bb07263329a5fd4$var$rgb2num = (...args)=>{
    const [r, g, b] = (0, $4e4c67bc5c6fc98d$export$2e2bcd8739ae039)(args, 'rgb');
    return (r << 16) + (g << 8) + b;
};
var $3bb07263329a5fd4$export$2e2bcd8739ae039 = $3bb07263329a5fd4$var$rgb2num;


(0, $73c73657cae9064a$export$2e2bcd8739ae039).prototype.num = function() {
    return (0, $3bb07263329a5fd4$export$2e2bcd8739ae039)(this._rgb);
};
(0, $311ec6bd16e186d1$export$2e2bcd8739ae039).num = (...args)=>new (0, $73c73657cae9064a$export$2e2bcd8739ae039)(...args, 'num');
(0, $8f39e66366edca09$export$2e2bcd8739ae039).format.num = (0, $dcf3fedce6cf0351$export$2e2bcd8739ae039);
(0, $8f39e66366edca09$export$2e2bcd8739ae039).autodetect.push({
    p: 5,
    test: (...args)=>{
        if (args.length === 1 && (0, $052f087f906e983c$export$2e2bcd8739ae039)(args[0]) === 'number' && args[0] >= 0 && args[0] <= 0xffffff) return 'num';
    }
});






const { round: $79bdc158fc708d5b$var$round } = Math;
(0, $73c73657cae9064a$export$2e2bcd8739ae039).prototype.rgb = function(rnd = true) {
    if (rnd === false) return this._rgb.slice(0, 3);
    return this._rgb.slice(0, 3).map($79bdc158fc708d5b$var$round);
};
(0, $73c73657cae9064a$export$2e2bcd8739ae039).prototype.rgba = function(rnd = true) {
    return this._rgb.slice(0, 4).map((v, i)=>{
        return i < 3 ? rnd === false ? v : $79bdc158fc708d5b$var$round(v) : v;
    });
};
(0, $311ec6bd16e186d1$export$2e2bcd8739ae039).rgb = (...args)=>new (0, $73c73657cae9064a$export$2e2bcd8739ae039)(...args, 'rgb');
(0, $8f39e66366edca09$export$2e2bcd8739ae039).format.rgb = (...args)=>{
    const rgba = (0, $4e4c67bc5c6fc98d$export$2e2bcd8739ae039)(args, 'rgba');
    if (rgba[3] === undefined) rgba[3] = 1;
    return rgba;
};
(0, $8f39e66366edca09$export$2e2bcd8739ae039).autodetect.push({
    p: 3,
    test: (...args)=>{
        args = (0, $4e4c67bc5c6fc98d$export$2e2bcd8739ae039)(args, 'rgba');
        if ((0, $052f087f906e983c$export$2e2bcd8739ae039)(args) === 'array' && (args.length === 3 || args.length === 4 && (0, $052f087f906e983c$export$2e2bcd8739ae039)(args[3]) == 'number' && args[3] >= 0 && args[3] <= 1)) return 'rgb';
    }
});





/*
 * Based on implementation by Neil Bartlett
 * https://github.com/neilbartlett/color-temperature
 */ const { log: $f05e4842a8adc61b$var$log } = Math;
const $f05e4842a8adc61b$var$temperature2rgb = (kelvin)=>{
    const temp = kelvin / 100;
    let r, g, b;
    if (temp < 66) {
        r = 255;
        g = temp < 6 ? 0 : -155.25485562709179 - 0.44596950469579133 * (g = temp - 2) + 104.49216199393888 * $f05e4842a8adc61b$var$log(g);
        b = temp < 20 ? 0 : -254.76935184120902 + 0.8274096064007395 * (b = temp - 10) + 115.67994401066147 * $f05e4842a8adc61b$var$log(b);
    } else {
        r = 351.97690566805693 + 0.114206453784165 * (r = temp - 55) - 40.25366309332127 * $f05e4842a8adc61b$var$log(r);
        g = 325.4494125711974 + 0.07943456536662342 * (g = temp - 50) - 28.0852963507957 * $f05e4842a8adc61b$var$log(g);
        b = 255;
    }
    return [
        r,
        g,
        b,
        1
    ];
};
var $f05e4842a8adc61b$export$2e2bcd8739ae039 = $f05e4842a8adc61b$var$temperature2rgb;


/*
 * Based on implementation by Neil Bartlett
 * https://github.com/neilbartlett/color-temperature
 **/ 

const { round: $7eb057931f632797$var$round } = Math;
const $7eb057931f632797$var$rgb2temperature = (...args)=>{
    const rgb = (0, $4e4c67bc5c6fc98d$export$2e2bcd8739ae039)(args, 'rgb');
    const r = rgb[0], b = rgb[2];
    let minTemp = 1000;
    let maxTemp = 40000;
    const eps = 0.4;
    let temp;
    while(maxTemp - minTemp > eps){
        temp = (maxTemp + minTemp) * 0.5;
        const rgb = (0, $f05e4842a8adc61b$export$2e2bcd8739ae039)(temp);
        if (rgb[2] / rgb[0] >= b / r) maxTemp = temp;
        else minTemp = temp;
    }
    return $7eb057931f632797$var$round(temp);
};
var $7eb057931f632797$export$2e2bcd8739ae039 = $7eb057931f632797$var$rgb2temperature;


(0, $73c73657cae9064a$export$2e2bcd8739ae039).prototype.temp = (0, $73c73657cae9064a$export$2e2bcd8739ae039).prototype.kelvin = (0, $73c73657cae9064a$export$2e2bcd8739ae039).prototype.temperature = function() {
    return (0, $7eb057931f632797$export$2e2bcd8739ae039)(this._rgb);
};
(0, $311ec6bd16e186d1$export$2e2bcd8739ae039).temp = (0, $311ec6bd16e186d1$export$2e2bcd8739ae039).kelvin = (0, $311ec6bd16e186d1$export$2e2bcd8739ae039).temperature = (...args)=>new (0, $73c73657cae9064a$export$2e2bcd8739ae039)(...args, 'temp');
(0, $8f39e66366edca09$export$2e2bcd8739ae039).format.temp = (0, $8f39e66366edca09$export$2e2bcd8739ae039).format.kelvin = (0, $8f39e66366edca09$export$2e2bcd8739ae039).format.temperature = (0, $f05e4842a8adc61b$export$2e2bcd8739ae039);







const { pow: $56c87a69f80a33b0$var$pow, sign: $56c87a69f80a33b0$var$sign } = Math;
/*
 * L* [0..100]
 * a [-100..100]
 * b [-100..100]
 */ const $56c87a69f80a33b0$var$oklab2rgb = (...args)=>{
    args = (0, $4e4c67bc5c6fc98d$export$2e2bcd8739ae039)(args, 'lab');
    const [L, a, b] = args;
    const l = $56c87a69f80a33b0$var$pow(L + 0.3963377774 * a + 0.2158037573 * b, 3);
    const m = $56c87a69f80a33b0$var$pow(L - 0.1055613458 * a - 0.0638541728 * b, 3);
    const s = $56c87a69f80a33b0$var$pow(L - 0.0894841775 * a - 1.291485548 * b, 3);
    return [
        255 * $56c87a69f80a33b0$var$lrgb2rgb(4.0767416621 * l - 3.3077115913 * m + 0.2309699292 * s),
        255 * $56c87a69f80a33b0$var$lrgb2rgb(-1.2684380046 * l + 2.6097574011 * m - 0.3413193965 * s),
        255 * $56c87a69f80a33b0$var$lrgb2rgb(-0.0041960863 * l - 0.7034186147 * m + 1.707614701 * s),
        args.length > 3 ? args[3] : 1
    ];
};
var $56c87a69f80a33b0$export$2e2bcd8739ae039 = $56c87a69f80a33b0$var$oklab2rgb;
function $56c87a69f80a33b0$var$lrgb2rgb(c) {
    const abs = Math.abs(c);
    if (abs > 0.0031308) return ($56c87a69f80a33b0$var$sign(c) || 1) * (1.055 * $56c87a69f80a33b0$var$pow(abs, 1 / 2.4) - 0.055);
    return c * 12.92;
}



const { cbrt: $2f68fa8e6563926b$var$cbrt, pow: $2f68fa8e6563926b$var$pow, sign: $2f68fa8e6563926b$var$sign } = Math;
const $2f68fa8e6563926b$var$rgb2oklab = (...args)=>{
    // OKLab color space implementation taken from
    // https://bottosson.github.io/posts/oklab/
    const [r, g, b] = (0, $4e4c67bc5c6fc98d$export$2e2bcd8739ae039)(args, 'rgb');
    const [lr, lg, lb] = [
        $2f68fa8e6563926b$var$rgb2lrgb(r / 255),
        $2f68fa8e6563926b$var$rgb2lrgb(g / 255),
        $2f68fa8e6563926b$var$rgb2lrgb(b / 255)
    ];
    const l = $2f68fa8e6563926b$var$cbrt(0.4122214708 * lr + 0.5363325363 * lg + 0.0514459929 * lb);
    const m = $2f68fa8e6563926b$var$cbrt(0.2119034982 * lr + 0.6806995451 * lg + 0.1073969566 * lb);
    const s = $2f68fa8e6563926b$var$cbrt(0.0883024619 * lr + 0.2817188376 * lg + 0.6299787005 * lb);
    return [
        0.2104542553 * l + 0.793617785 * m - 0.0040720468 * s,
        1.9779984951 * l - 2.428592205 * m + 0.4505937099 * s,
        0.0259040371 * l + 0.7827717662 * m - 0.808675766 * s
    ];
};
var $2f68fa8e6563926b$export$2e2bcd8739ae039 = $2f68fa8e6563926b$var$rgb2oklab;
function $2f68fa8e6563926b$var$rgb2lrgb(c) {
    const abs = Math.abs(c);
    if (abs < 0.04045) return c / 12.92;
    return ($2f68fa8e6563926b$var$sign(c) || 1) * $2f68fa8e6563926b$var$pow((abs + 0.055) / 1.055, 2.4);
}


(0, $73c73657cae9064a$export$2e2bcd8739ae039).prototype.oklab = function() {
    return (0, $2f68fa8e6563926b$export$2e2bcd8739ae039)(this._rgb);
};
(0, $311ec6bd16e186d1$export$2e2bcd8739ae039).oklab = (...args)=>new (0, $73c73657cae9064a$export$2e2bcd8739ae039)(...args, 'oklab');
(0, $8f39e66366edca09$export$2e2bcd8739ae039).format.oklab = (0, $56c87a69f80a33b0$export$2e2bcd8739ae039);
(0, $8f39e66366edca09$export$2e2bcd8739ae039).autodetect.push({
    p: 3,
    test: (...args)=>{
        args = (0, $4e4c67bc5c6fc98d$export$2e2bcd8739ae039)(args, 'oklab');
        if ((0, $052f087f906e983c$export$2e2bcd8739ae039)(args) === 'array' && args.length === 3) return 'oklab';
    }
});









const $8739bfbc33889254$var$oklch2rgb = (...args)=>{
    args = (0, $4e4c67bc5c6fc98d$export$2e2bcd8739ae039)(args, 'lch');
    const [l, c, h] = args;
    const [L, a, b_] = (0, $11c384502518f696$export$2e2bcd8739ae039)(l, c, h);
    const [r, g, b] = (0, $56c87a69f80a33b0$export$2e2bcd8739ae039)(L, a, b_);
    return [
        r,
        g,
        b,
        args.length > 3 ? args[3] : 1
    ];
};
var $8739bfbc33889254$export$2e2bcd8739ae039 = $8739bfbc33889254$var$oklch2rgb;





const $cdfbea047f0b9913$var$rgb2oklch = (...args)=>{
    const [r, g, b] = (0, $4e4c67bc5c6fc98d$export$2e2bcd8739ae039)(args, 'rgb');
    const [l, a, b_] = (0, $2f68fa8e6563926b$export$2e2bcd8739ae039)(r, g, b);
    return (0, $dea01d9fa2b6ac43$export$2e2bcd8739ae039)(l, a, b_);
};
var $cdfbea047f0b9913$export$2e2bcd8739ae039 = $cdfbea047f0b9913$var$rgb2oklch;


(0, $73c73657cae9064a$export$2e2bcd8739ae039).prototype.oklch = function() {
    return (0, $cdfbea047f0b9913$export$2e2bcd8739ae039)(this._rgb);
};
(0, $311ec6bd16e186d1$export$2e2bcd8739ae039).oklch = (...args)=>new (0, $73c73657cae9064a$export$2e2bcd8739ae039)(...args, 'oklch');
(0, $8f39e66366edca09$export$2e2bcd8739ae039).format.oklch = (0, $8739bfbc33889254$export$2e2bcd8739ae039);
(0, $8f39e66366edca09$export$2e2bcd8739ae039).autodetect.push({
    p: 3,
    test: (...args)=>{
        args = (0, $4e4c67bc5c6fc98d$export$2e2bcd8739ae039)(args, 'oklch');
        if ((0, $052f087f906e983c$export$2e2bcd8739ae039)(args) === 'array' && args.length === 3) return 'oklch';
    }
});




(0, $73c73657cae9064a$export$2e2bcd8739ae039).prototype.alpha = function(a, mutate = false) {
    if (a !== undefined && (0, $052f087f906e983c$export$2e2bcd8739ae039)(a) === 'number') {
        if (mutate) {
            this._rgb[3] = a;
            return this;
        }
        return new (0, $73c73657cae9064a$export$2e2bcd8739ae039)([
            this._rgb[0],
            this._rgb[1],
            this._rgb[2],
            a
        ], 'rgb');
    }
    return this._rgb[3];
};



(0, $73c73657cae9064a$export$2e2bcd8739ae039).prototype.clipped = function() {
    return this._rgb._clipped || false;
};





(0, $73c73657cae9064a$export$2e2bcd8739ae039).prototype.darken = function(amount = 1) {
    const me = this;
    const lab = me.lab();
    lab[0] -= (0, $e5e786d1c89b5967$export$2e2bcd8739ae039).Kn * amount;
    return new (0, $73c73657cae9064a$export$2e2bcd8739ae039)(lab, 'lab').alpha(me.alpha(), true);
};
(0, $73c73657cae9064a$export$2e2bcd8739ae039).prototype.brighten = function(amount = 1) {
    return this.darken(-amount);
};
(0, $73c73657cae9064a$export$2e2bcd8739ae039).prototype.darker = (0, $73c73657cae9064a$export$2e2bcd8739ae039).prototype.darken;
(0, $73c73657cae9064a$export$2e2bcd8739ae039).prototype.brighter = (0, $73c73657cae9064a$export$2e2bcd8739ae039).prototype.brighten;



(0, $73c73657cae9064a$export$2e2bcd8739ae039).prototype.get = function(mc) {
    const [mode, channel] = mc.split('.');
    const src = this[mode]();
    if (channel) {
        const i = mode.indexOf(channel) - (mode.substr(0, 2) === 'ok' ? 2 : 0);
        if (i > -1) return src[i];
        throw new Error(`unknown channel ${channel} in mode ${mode}`);
    } else return src;
};




const { pow: $6af8fcc29ad49290$var$pow } = Math;
const $6af8fcc29ad49290$var$EPS = 1e-7;
const $6af8fcc29ad49290$var$MAX_ITER = 20;
(0, $73c73657cae9064a$export$2e2bcd8739ae039).prototype.luminance = function(lum, mode = 'rgb') {
    if (lum !== undefined && (0, $052f087f906e983c$export$2e2bcd8739ae039)(lum) === 'number') {
        if (lum === 0) // return pure black
        return new (0, $73c73657cae9064a$export$2e2bcd8739ae039)([
            0,
            0,
            0,
            this._rgb[3]
        ], 'rgb');
        if (lum === 1) // return pure white
        return new (0, $73c73657cae9064a$export$2e2bcd8739ae039)([
            255,
            255,
            255,
            this._rgb[3]
        ], 'rgb');
        // compute new color using...
        let cur_lum = this.luminance();
        let max_iter = $6af8fcc29ad49290$var$MAX_ITER;
        const test = (low, high)=>{
            const mid = low.interpolate(high, 0.5, mode);
            const lm = mid.luminance();
            if (Math.abs(lum - lm) < $6af8fcc29ad49290$var$EPS || !max_iter--) // close enough
            return mid;
            return lm > lum ? test(low, mid) : test(mid, high);
        };
        const rgb = (cur_lum > lum ? test(new (0, $73c73657cae9064a$export$2e2bcd8739ae039)([
            0,
            0,
            0
        ]), this) : test(this, new (0, $73c73657cae9064a$export$2e2bcd8739ae039)([
            255,
            255,
            255
        ]))).rgb();
        return new (0, $73c73657cae9064a$export$2e2bcd8739ae039)([
            ...rgb,
            this._rgb[3]
        ]);
    }
    return $6af8fcc29ad49290$var$rgb2luminance(...this._rgb.slice(0, 3));
};
const $6af8fcc29ad49290$var$rgb2luminance = (r, g, b)=>{
    // relative luminance
    // see http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
    r = $6af8fcc29ad49290$var$luminance_x(r);
    g = $6af8fcc29ad49290$var$luminance_x(g);
    b = $6af8fcc29ad49290$var$luminance_x(b);
    return 0.2126 * r + 0.7152 * g + 0.0722 * b;
};
const $6af8fcc29ad49290$var$luminance_x = (x)=>{
    x /= 255;
    return x <= 0.03928 ? x / 12.92 : $6af8fcc29ad49290$var$pow((x + 0.055) / 1.055, 2.4);
};





var $2f731e83e3211502$export$2e2bcd8739ae039 = {};


var $36049a9f16a5dcac$export$2e2bcd8739ae039 = (col1, col2, f = 0.5, ...rest)=>{
    let mode = rest[0] || 'lrgb';
    if (!(0, $2f731e83e3211502$export$2e2bcd8739ae039)[mode] && !rest.length) // fall back to the first supported mode
    mode = Object.keys((0, $2f731e83e3211502$export$2e2bcd8739ae039))[0];
    if (!(0, $2f731e83e3211502$export$2e2bcd8739ae039)[mode]) throw new Error(`interpolation mode ${mode} is not defined`);
    if ((0, $052f087f906e983c$export$2e2bcd8739ae039)(col1) !== 'object') col1 = new (0, $73c73657cae9064a$export$2e2bcd8739ae039)(col1);
    if ((0, $052f087f906e983c$export$2e2bcd8739ae039)(col2) !== 'object') col2 = new (0, $73c73657cae9064a$export$2e2bcd8739ae039)(col2);
    return (0, $2f731e83e3211502$export$2e2bcd8739ae039)[mode](col1, col2, f).alpha(col1.alpha() + f * (col2.alpha() - col1.alpha()));
};


(0, $73c73657cae9064a$export$2e2bcd8739ae039).prototype.mix = (0, $73c73657cae9064a$export$2e2bcd8739ae039).prototype.interpolate = function(col2, f = 0.5, ...rest) {
    return (0, $36049a9f16a5dcac$export$2e2bcd8739ae039)(this, col2, f, ...rest);
};



(0, $73c73657cae9064a$export$2e2bcd8739ae039).prototype.premultiply = function(mutate = false) {
    const rgb = this._rgb;
    const a = rgb[3];
    if (mutate) {
        this._rgb = [
            rgb[0] * a,
            rgb[1] * a,
            rgb[2] * a,
            a
        ];
        return this;
    } else return new (0, $73c73657cae9064a$export$2e2bcd8739ae039)([
        rgb[0] * a,
        rgb[1] * a,
        rgb[2] * a,
        a
    ], 'rgb');
};





(0, $73c73657cae9064a$export$2e2bcd8739ae039).prototype.saturate = function(amount = 1) {
    const me = this;
    const lch = me.lch();
    lch[1] += (0, $e5e786d1c89b5967$export$2e2bcd8739ae039).Kn * amount;
    if (lch[1] < 0) lch[1] = 0;
    return new (0, $73c73657cae9064a$export$2e2bcd8739ae039)(lch, 'lch').alpha(me.alpha(), true);
};
(0, $73c73657cae9064a$export$2e2bcd8739ae039).prototype.desaturate = function(amount = 1) {
    return this.saturate(-amount);
};




(0, $73c73657cae9064a$export$2e2bcd8739ae039).prototype.set = function(mc, value, mutate = false) {
    const [mode, channel] = mc.split('.');
    const src = this[mode]();
    if (channel) {
        const i = mode.indexOf(channel) - (mode.substr(0, 2) === 'ok' ? 2 : 0);
        if (i > -1) {
            if ((0, $052f087f906e983c$export$2e2bcd8739ae039)(value) == 'string') switch(value.charAt(0)){
                case '+':
                    src[i] += +value;
                    break;
                case '-':
                    src[i] += +value;
                    break;
                case '*':
                    src[i] *= +value.substr(1);
                    break;
                case '/':
                    src[i] /= +value.substr(1);
                    break;
                default:
                    src[i] = +value;
            }
            else if ((0, $052f087f906e983c$export$2e2bcd8739ae039)(value) === 'number') src[i] = value;
            else throw new Error(`unsupported value for Color.set`);
            const out = new (0, $73c73657cae9064a$export$2e2bcd8739ae039)(src, mode);
            if (mutate) {
                this._rgb = out._rgb;
                return this;
            }
            return out;
        }
        throw new Error(`unknown channel ${channel} in mode ${mode}`);
    } else return src;
};





(0, $73c73657cae9064a$export$2e2bcd8739ae039).prototype.tint = function(f = 0.5, ...rest) {
    return (0, $36049a9f16a5dcac$export$2e2bcd8739ae039)(this, 'white', f, ...rest);
};
(0, $73c73657cae9064a$export$2e2bcd8739ae039).prototype.shade = function(f = 0.5, ...rest) {
    return (0, $36049a9f16a5dcac$export$2e2bcd8739ae039)(this, 'black', f, ...rest);
};




const $0a2ff6c965236cbc$var$rgb = (col1, col2, f)=>{
    const xyz0 = col1._rgb;
    const xyz1 = col2._rgb;
    return new (0, $73c73657cae9064a$export$2e2bcd8739ae039)(xyz0[0] + f * (xyz1[0] - xyz0[0]), xyz0[1] + f * (xyz1[1] - xyz0[1]), xyz0[2] + f * (xyz1[2] - xyz0[2]), 'rgb');
};
// register interpolator
(0, $2f731e83e3211502$export$2e2bcd8739ae039).rgb = $0a2ff6c965236cbc$var$rgb;
var $0a2ff6c965236cbc$export$2e2bcd8739ae039 = $0a2ff6c965236cbc$var$rgb;




const { sqrt: $92d1a76c2e906c2a$var$sqrt, pow: $92d1a76c2e906c2a$var$pow } = Math;
const $92d1a76c2e906c2a$var$lrgb = (col1, col2, f)=>{
    const [x1, y1, z1] = col1._rgb;
    const [x2, y2, z2] = col2._rgb;
    return new (0, $73c73657cae9064a$export$2e2bcd8739ae039)($92d1a76c2e906c2a$var$sqrt($92d1a76c2e906c2a$var$pow(x1, 2) * (1 - f) + $92d1a76c2e906c2a$var$pow(x2, 2) * f), $92d1a76c2e906c2a$var$sqrt($92d1a76c2e906c2a$var$pow(y1, 2) * (1 - f) + $92d1a76c2e906c2a$var$pow(y2, 2) * f), $92d1a76c2e906c2a$var$sqrt($92d1a76c2e906c2a$var$pow(z1, 2) * (1 - f) + $92d1a76c2e906c2a$var$pow(z2, 2) * f), 'rgb');
};
// register interpolator
(0, $2f731e83e3211502$export$2e2bcd8739ae039).lrgb = $92d1a76c2e906c2a$var$lrgb;
var $92d1a76c2e906c2a$export$2e2bcd8739ae039 = $92d1a76c2e906c2a$var$lrgb;





const $f29213695a0a0638$var$lab = (col1, col2, f)=>{
    const xyz0 = col1.lab();
    const xyz1 = col2.lab();
    return new (0, $73c73657cae9064a$export$2e2bcd8739ae039)(xyz0[0] + f * (xyz1[0] - xyz0[0]), xyz0[1] + f * (xyz1[1] - xyz0[1]), xyz0[2] + f * (xyz1[2] - xyz0[2]), 'lab');
};
// register interpolator
(0, $2f731e83e3211502$export$2e2bcd8739ae039).lab = $f29213695a0a0638$var$lab;
var $f29213695a0a0638$export$2e2bcd8739ae039 = $f29213695a0a0638$var$lab;




var $ee76e2650e18cb93$export$2e2bcd8739ae039 = (col1, col2, f, m)=>{
    let xyz0, xyz1;
    if (m === 'hsl') {
        xyz0 = col1.hsl();
        xyz1 = col2.hsl();
    } else if (m === 'hsv') {
        xyz0 = col1.hsv();
        xyz1 = col2.hsv();
    } else if (m === 'hcg') {
        xyz0 = col1.hcg();
        xyz1 = col2.hcg();
    } else if (m === 'hsi') {
        xyz0 = col1.hsi();
        xyz1 = col2.hsi();
    } else if (m === 'lch' || m === 'hcl') {
        m = 'hcl';
        xyz0 = col1.hcl();
        xyz1 = col2.hcl();
    } else if (m === 'oklch') {
        xyz0 = col1.oklch().reverse();
        xyz1 = col2.oklch().reverse();
    }
    let hue0, hue1, sat0, sat1, lbv0, lbv1;
    if (m.substr(0, 1) === 'h' || m === 'oklch') {
        [hue0, sat0, lbv0] = xyz0;
        [hue1, sat1, lbv1] = xyz1;
    }
    let sat, hue, lbv, dh;
    if (!isNaN(hue0) && !isNaN(hue1)) {
        // both colors have hue
        if (hue1 > hue0 && hue1 - hue0 > 180) dh = hue1 - (hue0 + 360);
        else if (hue1 < hue0 && hue0 - hue1 > 180) dh = hue1 + 360 - hue0;
        else dh = hue1 - hue0;
        hue = hue0 + f * dh;
    } else if (!isNaN(hue0)) {
        hue = hue0;
        if ((lbv1 == 1 || lbv1 == 0) && m != 'hsv') sat = sat0;
    } else if (!isNaN(hue1)) {
        hue = hue1;
        if ((lbv0 == 1 || lbv0 == 0) && m != 'hsv') sat = sat1;
    } else hue = Number.NaN;
    if (sat === undefined) sat = sat0 + f * (sat1 - sat0);
    lbv = lbv0 + f * (lbv1 - lbv0);
    return m === 'oklch' ? new (0, $73c73657cae9064a$export$2e2bcd8739ae039)([
        lbv,
        sat,
        hue
    ], m) : new (0, $73c73657cae9064a$export$2e2bcd8739ae039)([
        hue,
        sat,
        lbv
    ], m);
};



const $e67ca313b7b33db9$var$lch = (col1, col2, f)=>{
    return (0, $ee76e2650e18cb93$export$2e2bcd8739ae039)(col1, col2, f, 'lch');
};
// register interpolator
(0, $2f731e83e3211502$export$2e2bcd8739ae039).lch = $e67ca313b7b33db9$var$lch;
(0, $2f731e83e3211502$export$2e2bcd8739ae039).hcl = $e67ca313b7b33db9$var$lch;
var $e67ca313b7b33db9$export$2e2bcd8739ae039 = $e67ca313b7b33db9$var$lch;





const $151387b881e24d5f$var$num = (col1, col2, f)=>{
    const c1 = col1.num();
    const c2 = col2.num();
    return new (0, $73c73657cae9064a$export$2e2bcd8739ae039)(c1 + f * (c2 - c1), 'num');
};
// register interpolator
(0, $2f731e83e3211502$export$2e2bcd8739ae039).num = $151387b881e24d5f$var$num;
var $151387b881e24d5f$export$2e2bcd8739ae039 = $151387b881e24d5f$var$num;





const $e2aaf02e811db4cb$var$hcg = (col1, col2, f)=>{
    return (0, $ee76e2650e18cb93$export$2e2bcd8739ae039)(col1, col2, f, 'hcg');
};
// register interpolator
(0, $2f731e83e3211502$export$2e2bcd8739ae039).hcg = $e2aaf02e811db4cb$var$hcg;
var $e2aaf02e811db4cb$export$2e2bcd8739ae039 = $e2aaf02e811db4cb$var$hcg;





const $c28c4fdb93d61fa1$var$hsi = (col1, col2, f)=>{
    return (0, $ee76e2650e18cb93$export$2e2bcd8739ae039)(col1, col2, f, 'hsi');
};
// register interpolator
(0, $2f731e83e3211502$export$2e2bcd8739ae039).hsi = $c28c4fdb93d61fa1$var$hsi;
var $c28c4fdb93d61fa1$export$2e2bcd8739ae039 = $c28c4fdb93d61fa1$var$hsi;





const $15936043af9f08c3$var$hsl = (col1, col2, f)=>{
    return (0, $ee76e2650e18cb93$export$2e2bcd8739ae039)(col1, col2, f, 'hsl');
};
// register interpolator
(0, $2f731e83e3211502$export$2e2bcd8739ae039).hsl = $15936043af9f08c3$var$hsl;
var $15936043af9f08c3$export$2e2bcd8739ae039 = $15936043af9f08c3$var$hsl;





const $d9255b9747dc8509$var$hsv = (col1, col2, f)=>{
    return (0, $ee76e2650e18cb93$export$2e2bcd8739ae039)(col1, col2, f, 'hsv');
};
// register interpolator
(0, $2f731e83e3211502$export$2e2bcd8739ae039).hsv = $d9255b9747dc8509$var$hsv;
var $d9255b9747dc8509$export$2e2bcd8739ae039 = $d9255b9747dc8509$var$hsv;





const $9202a8a2aba98a5f$var$oklab = (col1, col2, f)=>{
    const xyz0 = col1.oklab();
    const xyz1 = col2.oklab();
    return new (0, $73c73657cae9064a$export$2e2bcd8739ae039)(xyz0[0] + f * (xyz1[0] - xyz0[0]), xyz0[1] + f * (xyz1[1] - xyz0[1]), xyz0[2] + f * (xyz1[2] - xyz0[2]), 'oklab');
};
// register interpolator
(0, $2f731e83e3211502$export$2e2bcd8739ae039).oklab = $9202a8a2aba98a5f$var$oklab;
var $9202a8a2aba98a5f$export$2e2bcd8739ae039 = $9202a8a2aba98a5f$var$oklab;





const $9bc68aa2e5b3e350$var$oklch = (col1, col2, f)=>{
    return (0, $ee76e2650e18cb93$export$2e2bcd8739ae039)(col1, col2, f, 'oklch');
};
// register interpolator
(0, $2f731e83e3211502$export$2e2bcd8739ae039).oklch = $9bc68aa2e5b3e350$var$oklch;
var $9bc68aa2e5b3e350$export$2e2bcd8739ae039 = $9bc68aa2e5b3e350$var$oklch;




const { pow: $12dd7fa91b00d6d8$var$pow, sqrt: $12dd7fa91b00d6d8$var$sqrt, PI: $12dd7fa91b00d6d8$var$PI, cos: $12dd7fa91b00d6d8$var$cos, sin: $12dd7fa91b00d6d8$var$sin, atan2: $12dd7fa91b00d6d8$var$atan2 } = Math;
var $12dd7fa91b00d6d8$export$2e2bcd8739ae039 = (colors, mode = 'lrgb', weights = null)=>{
    const l = colors.length;
    if (!weights) weights = Array.from(new Array(l)).map(()=>1);
    // normalize weights
    const k = l / weights.reduce(function(a, b) {
        return a + b;
    });
    weights.forEach((w, i)=>{
        weights[i] *= k;
    });
    // convert colors to Color objects
    colors = colors.map((c)=>new (0, $73c73657cae9064a$export$2e2bcd8739ae039)(c));
    if (mode === 'lrgb') return $12dd7fa91b00d6d8$var$_average_lrgb(colors, weights);
    const first = colors.shift();
    const xyz = first.get(mode);
    const cnt = [];
    let dx = 0;
    let dy = 0;
    // initial color
    for(let i = 0; i < xyz.length; i++){
        xyz[i] = (xyz[i] || 0) * weights[0];
        cnt.push(isNaN(xyz[i]) ? 0 : weights[0]);
        if (mode.charAt(i) === 'h' && !isNaN(xyz[i])) {
            const A = xyz[i] / 180 * $12dd7fa91b00d6d8$var$PI;
            dx += $12dd7fa91b00d6d8$var$cos(A) * weights[0];
            dy += $12dd7fa91b00d6d8$var$sin(A) * weights[0];
        }
    }
    let alpha = first.alpha() * weights[0];
    colors.forEach((c, ci)=>{
        const xyz2 = c.get(mode);
        alpha += c.alpha() * weights[ci + 1];
        for(let i = 0; i < xyz.length; i++)if (!isNaN(xyz2[i])) {
            cnt[i] += weights[ci + 1];
            if (mode.charAt(i) === 'h') {
                const A = xyz2[i] / 180 * $12dd7fa91b00d6d8$var$PI;
                dx += $12dd7fa91b00d6d8$var$cos(A) * weights[ci + 1];
                dy += $12dd7fa91b00d6d8$var$sin(A) * weights[ci + 1];
            } else xyz[i] += xyz2[i] * weights[ci + 1];
        }
    });
    for(let i = 0; i < xyz.length; i++)if (mode.charAt(i) === 'h') {
        let A = $12dd7fa91b00d6d8$var$atan2(dy / cnt[i], dx / cnt[i]) / $12dd7fa91b00d6d8$var$PI * 180;
        while(A < 0)A += 360;
        while(A >= 360)A -= 360;
        xyz[i] = A;
    } else xyz[i] = xyz[i] / cnt[i];
    alpha /= l;
    return new (0, $73c73657cae9064a$export$2e2bcd8739ae039)(xyz, mode).alpha(alpha > 0.99999 ? 1 : alpha, true);
};
const $12dd7fa91b00d6d8$var$_average_lrgb = (colors, weights)=>{
    const l = colors.length;
    const xyz = [
        0,
        0,
        0,
        0
    ];
    for(let i = 0; i < colors.length; i++){
        const col = colors[i];
        const f = weights[i] / l;
        const rgb = col._rgb;
        xyz[0] += $12dd7fa91b00d6d8$var$pow(rgb[0], 2) * f;
        xyz[1] += $12dd7fa91b00d6d8$var$pow(rgb[1], 2) * f;
        xyz[2] += $12dd7fa91b00d6d8$var$pow(rgb[2], 2) * f;
        xyz[3] += rgb[3] * f;
    }
    xyz[0] = $12dd7fa91b00d6d8$var$sqrt(xyz[0]);
    xyz[1] = $12dd7fa91b00d6d8$var$sqrt(xyz[1]);
    xyz[2] = $12dd7fa91b00d6d8$var$sqrt(xyz[2]);
    if (xyz[3] > 0.9999999) xyz[3] = 1;
    return new (0, $73c73657cae9064a$export$2e2bcd8739ae039)((0, $dacfc2a564661593$export$2e2bcd8739ae039)(xyz));
};


//
// interpolates between a set of colors uzing a bezier spline
//
// @requires utils lab


// minimal multi-purpose interface
// @requires utils color analyze


const { pow: $24c5a8a3d239afb3$var$pow } = Math;
function $24c5a8a3d239afb3$export$2e2bcd8739ae039(colors) {
    // constructor
    let _mode = 'rgb';
    let _nacol = (0, $311ec6bd16e186d1$export$2e2bcd8739ae039)('#ccc');
    let _spread = 0;
    // const _fixed = false;
    let _domain = [
        0,
        1
    ];
    let _pos = [];
    let _padding = [
        0,
        0
    ];
    let _classes = false;
    let _colors = [];
    let _out = false;
    let _min = 0;
    let _max = 1;
    let _correctLightness = false;
    let _colorCache = {};
    let _useCache = true;
    let _gamma = 1;
    // private methods
    const setColors = function(colors) {
        colors = colors || [
            '#fff',
            '#000'
        ];
        if (colors && (0, $052f087f906e983c$export$2e2bcd8739ae039)(colors) === 'string' && (0, $311ec6bd16e186d1$export$2e2bcd8739ae039).brewer && (0, $311ec6bd16e186d1$export$2e2bcd8739ae039).brewer[colors.toLowerCase()]) colors = (0, $311ec6bd16e186d1$export$2e2bcd8739ae039).brewer[colors.toLowerCase()];
        if ((0, $052f087f906e983c$export$2e2bcd8739ae039)(colors) === 'array') {
            // handle single color
            if (colors.length === 1) colors = [
                colors[0],
                colors[0]
            ];
            // make a copy of the colors
            colors = colors.slice(0);
            // convert to chroma classes
            for(let c = 0; c < colors.length; c++)colors[c] = (0, $311ec6bd16e186d1$export$2e2bcd8739ae039)(colors[c]);
            // auto-fill color position
            _pos.length = 0;
            for(let c = 0; c < colors.length; c++)_pos.push(c / (colors.length - 1));
        }
        resetCache();
        return _colors = colors;
    };
    const getClass = function(value) {
        if (_classes != null) {
            const n = _classes.length - 1;
            let i = 0;
            while(i < n && value >= _classes[i])i++;
            return i - 1;
        }
        return 0;
    };
    let tMapLightness = (t)=>t;
    let tMapDomain = (t)=>t;
    // const classifyValue = function(value) {
    //     let val = value;
    //     if (_classes.length > 2) {
    //         const n = _classes.length-1;
    //         const i = getClass(value);
    //         const minc = _classes[0] + ((_classes[1]-_classes[0]) * (0 + (_spread * 0.5)));  // center of 1st class
    //         const maxc = _classes[n-1] + ((_classes[n]-_classes[n-1]) * (1 - (_spread * 0.5)));  // center of last class
    //         val = _min + ((((_classes[i] + ((_classes[i+1] - _classes[i]) * 0.5)) - minc) / (maxc-minc)) * (_max - _min));
    //     }
    //     return val;
    // };
    const getColor = function(val, bypassMap) {
        let col, t;
        if (bypassMap == null) bypassMap = false;
        if (isNaN(val) || val === null) return _nacol;
        if (!bypassMap) {
            if (_classes && _classes.length > 2) {
                // find the class
                const c = getClass(val);
                t = c / (_classes.length - 2);
            } else if (_max !== _min) // just interpolate between min/max
            t = (val - _min) / (_max - _min);
            else t = 1;
        } else t = val;
        // domain map
        t = tMapDomain(t);
        if (!bypassMap) t = tMapLightness(t); // lightness correction
        if (_gamma !== 1) t = $24c5a8a3d239afb3$var$pow(t, _gamma);
        t = _padding[0] + t * (1 - _padding[0] - _padding[1]);
        t = (0, $a5cdb2d1e654e868$export$2e2bcd8739ae039)(t, 0, 1);
        const k = Math.floor(t * 10000);
        if (_useCache && _colorCache[k]) col = _colorCache[k];
        else {
            if ((0, $052f087f906e983c$export$2e2bcd8739ae039)(_colors) === 'array') //for i in [0.._pos.length-1]
            for(let i = 0; i < _pos.length; i++){
                const p = _pos[i];
                if (t <= p) {
                    col = _colors[i];
                    break;
                }
                if (t >= p && i === _pos.length - 1) {
                    col = _colors[i];
                    break;
                }
                if (t > p && t < _pos[i + 1]) {
                    t = (t - p) / (_pos[i + 1] - p);
                    col = (0, $311ec6bd16e186d1$export$2e2bcd8739ae039).interpolate(_colors[i], _colors[i + 1], t, _mode);
                    break;
                }
            }
            else if ((0, $052f087f906e983c$export$2e2bcd8739ae039)(_colors) === 'function') col = _colors(t);
            if (_useCache) _colorCache[k] = col;
        }
        return col;
    };
    var resetCache = ()=>_colorCache = {};
    setColors(colors);
    // public interface
    const f = function(v) {
        const c = (0, $311ec6bd16e186d1$export$2e2bcd8739ae039)(getColor(v));
        if (_out && c[_out]) return c[_out]();
        else return c;
    };
    f.classes = function(classes) {
        if (classes != null) {
            if ((0, $052f087f906e983c$export$2e2bcd8739ae039)(classes) === 'array') {
                _classes = classes;
                _domain = [
                    classes[0],
                    classes[classes.length - 1]
                ];
            } else {
                const d = (0, $311ec6bd16e186d1$export$2e2bcd8739ae039).analyze(_domain);
                if (classes === 0) _classes = [
                    d.min,
                    d.max
                ];
                else _classes = (0, $311ec6bd16e186d1$export$2e2bcd8739ae039).limits(d, 'e', classes);
            }
            return f;
        }
        return _classes;
    };
    f.domain = function(domain) {
        if (!arguments.length) return _domain;
        _min = domain[0];
        _max = domain[domain.length - 1];
        _pos = [];
        const k = _colors.length;
        if (domain.length === k && _min !== _max) // update positions
        for (let d of Array.from(domain))_pos.push((d - _min) / (_max - _min));
        else {
            for(let c = 0; c < k; c++)_pos.push(c / (k - 1));
            if (domain.length > 2) {
                // set domain map
                const tOut = domain.map((d, i)=>i / (domain.length - 1));
                const tBreaks = domain.map((d)=>(d - _min) / (_max - _min));
                if (!tBreaks.every((val, i)=>tOut[i] === val)) tMapDomain = (t)=>{
                    if (t <= 0 || t >= 1) return t;
                    let i = 0;
                    while(t >= tBreaks[i + 1])i++;
                    const f = (t - tBreaks[i]) / (tBreaks[i + 1] - tBreaks[i]);
                    const out = tOut[i] + f * (tOut[i + 1] - tOut[i]);
                    return out;
                };
            }
        }
        _domain = [
            _min,
            _max
        ];
        return f;
    };
    f.mode = function(_m) {
        if (!arguments.length) return _mode;
        _mode = _m;
        resetCache();
        return f;
    };
    f.range = function(colors, _pos) {
        setColors(colors, _pos);
        return f;
    };
    f.out = function(_o) {
        _out = _o;
        return f;
    };
    f.spread = function(val) {
        if (!arguments.length) return _spread;
        _spread = val;
        return f;
    };
    f.correctLightness = function(v) {
        if (v == null) v = true;
        _correctLightness = v;
        resetCache();
        if (_correctLightness) tMapLightness = function(t) {
            const L0 = getColor(0, true).lab()[0];
            const L1 = getColor(1, true).lab()[0];
            const pol = L0 > L1;
            let L_actual = getColor(t, true).lab()[0];
            const L_ideal = L0 + (L1 - L0) * t;
            let L_diff = L_actual - L_ideal;
            let t0 = 0;
            let t1 = 1;
            let max_iter = 20;
            while(Math.abs(L_diff) > 1e-2 && max_iter-- > 0)(function() {
                if (pol) L_diff *= -1;
                if (L_diff < 0) {
                    t0 = t;
                    t += (t1 - t) * 0.5;
                } else {
                    t1 = t;
                    t += (t0 - t) * 0.5;
                }
                L_actual = getColor(t, true).lab()[0];
                return L_diff = L_actual - L_ideal;
            })();
            return t;
        };
        else tMapLightness = (t)=>t;
        return f;
    };
    f.padding = function(p) {
        if (p != null) {
            if ((0, $052f087f906e983c$export$2e2bcd8739ae039)(p) === 'number') p = [
                p,
                p
            ];
            _padding = p;
            return f;
        } else return _padding;
    };
    f.colors = function(numColors, out) {
        // If no arguments are given, return the original colors that were provided
        if (arguments.length < 2) out = 'hex';
        let result = [];
        if (arguments.length === 0) result = _colors.slice(0);
        else if (numColors === 1) result = [
            f(0.5)
        ];
        else if (numColors > 1) {
            const dm = _domain[0];
            const dd = _domain[1] - dm;
            result = $24c5a8a3d239afb3$var$__range__(0, numColors, false).map((i)=>f(dm + i / (numColors - 1) * dd));
        } else {
            // returns all colors based on the defined classes
            colors = [];
            let samples = [];
            if (_classes && _classes.length > 2) for(let i = 1, end = _classes.length, asc = 1 <= end; asc ? i < end : i > end; asc ? i++ : i--)samples.push((_classes[i - 1] + _classes[i]) * 0.5);
            else samples = _domain;
            result = samples.map((v)=>f(v));
        }
        if ((0, $311ec6bd16e186d1$export$2e2bcd8739ae039)[out]) result = result.map((c)=>c[out]());
        return result;
    };
    f.cache = function(c) {
        if (c != null) {
            _useCache = c;
            return f;
        } else return _useCache;
    };
    f.gamma = function(g) {
        if (g != null) {
            _gamma = g;
            return f;
        } else return _gamma;
    };
    f.nodata = function(d) {
        if (d != null) {
            _nacol = (0, $311ec6bd16e186d1$export$2e2bcd8739ae039)(d);
            return f;
        } else return _nacol;
    };
    return f;
}
function $24c5a8a3d239afb3$var$__range__(left, right, inclusive) {
    let range = [];
    let ascending = left < right;
    let end = !inclusive ? right : ascending ? right + 1 : right - 1;
    for(let i = left; ascending ? i < end : i > end; ascending ? i++ : i--)range.push(i);
    return range;
}


// nth row of the pascal triangle
const $c7a2d3d03020c6d6$var$binom_row = function(n) {
    let row = [
        1,
        1
    ];
    for(let i = 1; i < n; i++){
        let newrow = [
            1
        ];
        for(let j = 1; j <= row.length; j++)newrow[j] = (row[j] || 0) + row[j - 1];
        row = newrow;
    }
    return row;
};
const $c7a2d3d03020c6d6$var$bezier = function(colors) {
    let I, lab0, lab1, lab2;
    colors = colors.map((c)=>new (0, $73c73657cae9064a$export$2e2bcd8739ae039)(c));
    if (colors.length === 2) {
        // linear interpolation
        [lab0, lab1] = colors.map((c)=>c.lab());
        I = function(t) {
            const lab = [
                0,
                1,
                2
            ].map((i)=>lab0[i] + t * (lab1[i] - lab0[i]));
            return new (0, $73c73657cae9064a$export$2e2bcd8739ae039)(lab, 'lab');
        };
    } else if (colors.length === 3) {
        // quadratic bezier interpolation
        [lab0, lab1, lab2] = colors.map((c)=>c.lab());
        I = function(t) {
            const lab = [
                0,
                1,
                2
            ].map((i)=>(1 - t) * (1 - t) * lab0[i] + 2 * (1 - t) * t * lab1[i] + t * t * lab2[i]);
            return new (0, $73c73657cae9064a$export$2e2bcd8739ae039)(lab, 'lab');
        };
    } else if (colors.length === 4) {
        // cubic bezier interpolation
        let lab3;
        [lab0, lab1, lab2, lab3] = colors.map((c)=>c.lab());
        I = function(t) {
            const lab = [
                0,
                1,
                2
            ].map((i)=>(1 - t) * (1 - t) * (1 - t) * lab0[i] + 3 * (1 - t) * (1 - t) * t * lab1[i] + 3 * (1 - t) * t * t * lab2[i] + t * t * t * lab3[i]);
            return new (0, $73c73657cae9064a$export$2e2bcd8739ae039)(lab, 'lab');
        };
    } else if (colors.length >= 5) {
        // general case (degree n bezier)
        let labs, row, n;
        labs = colors.map((c)=>c.lab());
        n = colors.length - 1;
        row = $c7a2d3d03020c6d6$var$binom_row(n);
        I = function(t) {
            const u = 1 - t;
            const lab = [
                0,
                1,
                2
            ].map((i)=>labs.reduce((sum, el, j)=>sum + row[j] * u ** (n - j) * t ** j * el[i], 0));
            return new (0, $73c73657cae9064a$export$2e2bcd8739ae039)(lab, 'lab');
        };
    } else throw new RangeError('No point in running bezier with only one color.');
    return I;
};
var $c7a2d3d03020c6d6$export$2e2bcd8739ae039 = (colors)=>{
    const f = $c7a2d3d03020c6d6$var$bezier(colors);
    f.scale = ()=>(0, $24c5a8a3d239afb3$export$2e2bcd8739ae039)(f);
    return f;
};


/*
 * interpolates between a set of colors uzing a bezier spline
 * blend mode formulas taken from https://web.archive.org/web/20180110014946/http://www.venture-ware.com/kevin/coding/lets-learn-math-photoshop-blend-modes/
 */ 

const $36d9f8b7360a85ad$var$blend = (bottom, top, mode)=>{
    if (!$36d9f8b7360a85ad$var$blend[mode]) throw new Error('unknown blend mode ' + mode);
    return $36d9f8b7360a85ad$var$blend[mode](bottom, top);
};
const $36d9f8b7360a85ad$var$blend_f = (f)=>(bottom, top)=>{
        const c0 = (0, $311ec6bd16e186d1$export$2e2bcd8739ae039)(top).rgb();
        const c1 = (0, $311ec6bd16e186d1$export$2e2bcd8739ae039)(bottom).rgb();
        return (0, $311ec6bd16e186d1$export$2e2bcd8739ae039).rgb(f(c0, c1));
    };
const $36d9f8b7360a85ad$var$each = (f)=>(c0, c1)=>{
        const out = [];
        out[0] = f(c0[0], c1[0]);
        out[1] = f(c0[1], c1[1]);
        out[2] = f(c0[2], c1[2]);
        return out;
    };
const $36d9f8b7360a85ad$var$normal = (a)=>a;
const $36d9f8b7360a85ad$var$multiply = (a, b)=>a * b / 255;
const $36d9f8b7360a85ad$var$darken = (a, b)=>a > b ? b : a;
const $36d9f8b7360a85ad$var$lighten = (a, b)=>a > b ? a : b;
const $36d9f8b7360a85ad$var$screen = (a, b)=>255 * (1 - (1 - a / 255) * (1 - b / 255));
const $36d9f8b7360a85ad$var$overlay = (a, b)=>b < 128 ? 2 * a * b / 255 : 255 * (1 - 2 * (1 - a / 255) * (1 - b / 255));
const $36d9f8b7360a85ad$var$burn = (a, b)=>255 * (1 - (1 - b / 255) / (a / 255));
const $36d9f8b7360a85ad$var$dodge = (a, b)=>{
    if (a === 255) return 255;
    a = 255 * (b / 255) / (1 - a / 255);
    return a > 255 ? 255 : a;
};
// # add = (a,b) ->
// #     if (a + b > 255) then 255 else a + b
$36d9f8b7360a85ad$var$blend.normal = $36d9f8b7360a85ad$var$blend_f($36d9f8b7360a85ad$var$each($36d9f8b7360a85ad$var$normal));
$36d9f8b7360a85ad$var$blend.multiply = $36d9f8b7360a85ad$var$blend_f($36d9f8b7360a85ad$var$each($36d9f8b7360a85ad$var$multiply));
$36d9f8b7360a85ad$var$blend.screen = $36d9f8b7360a85ad$var$blend_f($36d9f8b7360a85ad$var$each($36d9f8b7360a85ad$var$screen));
$36d9f8b7360a85ad$var$blend.overlay = $36d9f8b7360a85ad$var$blend_f($36d9f8b7360a85ad$var$each($36d9f8b7360a85ad$var$overlay));
$36d9f8b7360a85ad$var$blend.darken = $36d9f8b7360a85ad$var$blend_f($36d9f8b7360a85ad$var$each($36d9f8b7360a85ad$var$darken));
$36d9f8b7360a85ad$var$blend.lighten = $36d9f8b7360a85ad$var$blend_f($36d9f8b7360a85ad$var$each($36d9f8b7360a85ad$var$lighten));
$36d9f8b7360a85ad$var$blend.dodge = $36d9f8b7360a85ad$var$blend_f($36d9f8b7360a85ad$var$each($36d9f8b7360a85ad$var$dodge));
$36d9f8b7360a85ad$var$blend.burn = $36d9f8b7360a85ad$var$blend_f($36d9f8b7360a85ad$var$each($36d9f8b7360a85ad$var$burn));
var // blend.add = blend_f(each(add));
$36d9f8b7360a85ad$export$2e2bcd8739ae039 = $36d9f8b7360a85ad$var$blend;


// cubehelix interpolation
// based on D.A. Green "A colour scheme for the display of astronomical intensity images"
// http://astron-soc.in/bulletin/11June/289392011.pdf


const { pow: $8090a903719cad5a$var$pow, sin: $8090a903719cad5a$var$sin, cos: $8090a903719cad5a$var$cos } = Math;
function $8090a903719cad5a$export$2e2bcd8739ae039(start = 300, rotations = -1.5, hue = 1, gamma = 1, lightness = [
    0,
    1
]) {
    let dh = 0, dl;
    if ((0, $052f087f906e983c$export$2e2bcd8739ae039)(lightness) === 'array') dl = lightness[1] - lightness[0];
    else {
        dl = 0;
        lightness = [
            lightness,
            lightness
        ];
    }
    const f = function(fract) {
        const a = (0, $b055b672fea31fe3$export$af54f71c879f5ba9) * ((start + 120) / 360 + rotations * fract);
        const l = $8090a903719cad5a$var$pow(lightness[0] + dl * fract, gamma);
        const h = dh !== 0 ? hue[0] + fract * dh : hue;
        const amp = h * l * (1 - l) / 2;
        const cos_a = $8090a903719cad5a$var$cos(a);
        const sin_a = $8090a903719cad5a$var$sin(a);
        const r = l + amp * (-0.14861 * cos_a + 1.78277 * sin_a);
        const g = l + amp * (-0.29227 * cos_a - 0.90649 * sin_a);
        const b = l + amp * (1.97294 * cos_a);
        return (0, $311ec6bd16e186d1$export$2e2bcd8739ae039)((0, $dacfc2a564661593$export$2e2bcd8739ae039)([
            r * 255,
            g * 255,
            b * 255,
            1
        ]));
    };
    f.start = function(s) {
        if (s == null) return start;
        start = s;
        return f;
    };
    f.rotations = function(r) {
        if (r == null) return rotations;
        rotations = r;
        return f;
    };
    f.gamma = function(g) {
        if (g == null) return gamma;
        gamma = g;
        return f;
    };
    f.hue = function(h) {
        if (h == null) return hue;
        hue = h;
        if ((0, $052f087f906e983c$export$2e2bcd8739ae039)(hue) === 'array') {
            dh = hue[1] - hue[0];
            if (dh === 0) hue = hue[1];
        } else dh = 0;
        return f;
    };
    f.lightness = function(h) {
        if (h == null) return lightness;
        if ((0, $052f087f906e983c$export$2e2bcd8739ae039)(h) === 'array') {
            lightness = h;
            dl = h[1] - h[0];
        } else {
            lightness = [
                h,
                h
            ];
            dl = 0;
        }
        return f;
    };
    f.scale = ()=>(0, $311ec6bd16e186d1$export$2e2bcd8739ae039).scale(f);
    f.hue(hue);
    return f;
}




const $8f48ef595c9cfd89$var$digits = '0123456789abcdef';
const { floor: $8f48ef595c9cfd89$var$floor, random: $8f48ef595c9cfd89$var$random } = Math;
var $8f48ef595c9cfd89$export$2e2bcd8739ae039 = ()=>{
    let code = '#';
    for(let i = 0; i < 6; i++)code += $8f48ef595c9cfd89$var$digits.charAt($8f48ef595c9cfd89$var$floor($8f48ef595c9cfd89$var$random() * 16));
    return new (0, $73c73657cae9064a$export$2e2bcd8739ae039)(code, 'hex');
};




const { log: $9bdbebf464fb72d3$var$log, pow: $9bdbebf464fb72d3$var$pow, floor: $9bdbebf464fb72d3$var$floor, abs: $9bdbebf464fb72d3$var$abs } = Math;
function $9bdbebf464fb72d3$export$7cbcccfbecde6416(data, key = null) {
    const r = {
        min: Number.MAX_VALUE,
        max: Number.MAX_VALUE * -1,
        sum: 0,
        values: [],
        count: 0
    };
    if ((0, $052f087f906e983c$export$2e2bcd8739ae039)(data) === 'object') data = Object.values(data);
    data.forEach((val)=>{
        if (key && (0, $052f087f906e983c$export$2e2bcd8739ae039)(val) === 'object') val = val[key];
        if (val !== undefined && val !== null && !isNaN(val)) {
            r.values.push(val);
            r.sum += val;
            if (val < r.min) r.min = val;
            if (val > r.max) r.max = val;
            r.count += 1;
        }
    });
    r.domain = [
        r.min,
        r.max
    ];
    r.limits = (mode, num)=>$9bdbebf464fb72d3$export$e331ca4ad6a82555(r, mode, num);
    return r;
}
function $9bdbebf464fb72d3$export$e331ca4ad6a82555(data, mode = 'equal', num = 7) {
    if ((0, $052f087f906e983c$export$2e2bcd8739ae039)(data) == 'array') data = $9bdbebf464fb72d3$export$7cbcccfbecde6416(data);
    const { min: min, max: max } = data;
    const values = data.values.sort((a, b)=>a - b);
    if (num === 1) return [
        min,
        max
    ];
    const limits1 = [];
    if (mode.substr(0, 1) === 'c') {
        // continuous
        limits1.push(min);
        limits1.push(max);
    }
    if (mode.substr(0, 1) === 'e') {
        // equal interval
        limits1.push(min);
        for(let i = 1; i < num; i++)limits1.push(min + i / num * (max - min));
        limits1.push(max);
    } else if (mode.substr(0, 1) === 'l') {
        // log scale
        if (min <= 0) throw new Error('Logarithmic scales are only possible for values > 0');
        const min_log = Math.LOG10E * $9bdbebf464fb72d3$var$log(min);
        const max_log = Math.LOG10E * $9bdbebf464fb72d3$var$log(max);
        limits1.push(min);
        for(let i = 1; i < num; i++)limits1.push($9bdbebf464fb72d3$var$pow(10, min_log + i / num * (max_log - min_log)));
        limits1.push(max);
    } else if (mode.substr(0, 1) === 'q') {
        // quantile scale
        limits1.push(min);
        for(let i = 1; i < num; i++){
            const p = (values.length - 1) * i / num;
            const pb = $9bdbebf464fb72d3$var$floor(p);
            if (pb === p) limits1.push(values[pb]);
            else {
                // p > pb
                const pr = p - pb;
                limits1.push(values[pb] * (1 - pr) + values[pb + 1] * pr);
            }
        }
        limits1.push(max);
    } else if (mode.substr(0, 1) === 'k') {
        // k-means clustering
        /*
        implementation based on
        http://code.google.com/p/figue/source/browse/trunk/figue.js#336
        simplified for 1-d input values
        */ let cluster;
        const n = values.length;
        const assignments = new Array(n);
        const clusterSizes = new Array(num);
        let repeat = true;
        let nb_iters = 0;
        let centroids = null;
        // get seed values
        centroids = [];
        centroids.push(min);
        for(let i = 1; i < num; i++)centroids.push(min + i / num * (max - min));
        centroids.push(max);
        while(repeat){
            // assignment step
            for(let j = 0; j < num; j++)clusterSizes[j] = 0;
            for(let i = 0; i < n; i++){
                const value = values[i];
                let mindist = Number.MAX_VALUE;
                let best;
                for(let j = 0; j < num; j++){
                    const dist = $9bdbebf464fb72d3$var$abs(centroids[j] - value);
                    if (dist < mindist) {
                        mindist = dist;
                        best = j;
                    }
                    clusterSizes[best]++;
                    assignments[i] = best;
                }
            }
            // update centroids step
            const newCentroids = new Array(num);
            for(let j = 0; j < num; j++)newCentroids[j] = null;
            for(let i = 0; i < n; i++){
                cluster = assignments[i];
                if (newCentroids[cluster] === null) newCentroids[cluster] = values[i];
                else newCentroids[cluster] += values[i];
            }
            for(let j = 0; j < num; j++)newCentroids[j] *= 1 / clusterSizes[j];
            // check convergence
            repeat = false;
            for(let j = 0; j < num; j++)if (newCentroids[j] !== centroids[j]) {
                repeat = true;
                break;
            }
            centroids = newCentroids;
            nb_iters++;
            if (nb_iters > 200) repeat = false;
        }
        // finished k-means clustering
        // the next part is borrowed from gabrielflor.it
        const kClusters = {};
        for(let j = 0; j < num; j++)kClusters[j] = [];
        for(let i = 0; i < n; i++){
            cluster = assignments[i];
            kClusters[cluster].push(values[i]);
        }
        let tmpKMeansBreaks = [];
        for(let j = 0; j < num; j++){
            tmpKMeansBreaks.push(kClusters[j][0]);
            tmpKMeansBreaks.push(kClusters[j][kClusters[j].length - 1]);
        }
        tmpKMeansBreaks = tmpKMeansBreaks.sort((a, b)=>a - b);
        limits1.push(tmpKMeansBreaks[0]);
        for(let i = 1; i < tmpKMeansBreaks.length; i += 2){
            const v = tmpKMeansBreaks[i];
            if (!isNaN(v) && limits1.indexOf(v) === -1) limits1.push(v);
        }
    }
    return limits1;
}




var $dc105be0f4d2b0ec$export$2e2bcd8739ae039 = (a, b)=>{
    // WCAG contrast ratio
    // see http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef
    a = new (0, $73c73657cae9064a$export$2e2bcd8739ae039)(a);
    b = new (0, $73c73657cae9064a$export$2e2bcd8739ae039)(b);
    const l1 = a.luminance();
    const l2 = b.luminance();
    return l1 > l2 ? (l1 + 0.05) / (l2 + 0.05) : (l2 + 0.05) / (l1 + 0.05);
};



const { sqrt: $4fa34aef7ce53011$var$sqrt, pow: $4fa34aef7ce53011$var$pow, min: $4fa34aef7ce53011$var$min, max: $4fa34aef7ce53011$var$max, atan2: $4fa34aef7ce53011$var$atan2, abs: $4fa34aef7ce53011$var$abs, cos: $4fa34aef7ce53011$var$cos, sin: $4fa34aef7ce53011$var$sin, exp: $4fa34aef7ce53011$var$exp, PI: $4fa34aef7ce53011$var$PI } = Math;
function $4fa34aef7ce53011$export$2e2bcd8739ae039(a, b, Kl = 1, Kc = 1, Kh = 1) {
    // Delta E (CIE 2000)
    // see http://www.brucelindbloom.com/index.html?Eqn_DeltaE_CIE2000.html
    var rad2deg = function(rad) {
        return 360 * rad / (2 * $4fa34aef7ce53011$var$PI);
    };
    var deg2rad = function(deg) {
        return 2 * $4fa34aef7ce53011$var$PI * deg / 360;
    };
    a = new (0, $73c73657cae9064a$export$2e2bcd8739ae039)(a);
    b = new (0, $73c73657cae9064a$export$2e2bcd8739ae039)(b);
    const [L1, a1, b1] = Array.from(a.lab());
    const [L2, a2, b2] = Array.from(b.lab());
    const avgL = (L1 + L2) / 2;
    const C1 = $4fa34aef7ce53011$var$sqrt($4fa34aef7ce53011$var$pow(a1, 2) + $4fa34aef7ce53011$var$pow(b1, 2));
    const C2 = $4fa34aef7ce53011$var$sqrt($4fa34aef7ce53011$var$pow(a2, 2) + $4fa34aef7ce53011$var$pow(b2, 2));
    const avgC = (C1 + C2) / 2;
    const G = 0.5 * (1 - $4fa34aef7ce53011$var$sqrt($4fa34aef7ce53011$var$pow(avgC, 7) / ($4fa34aef7ce53011$var$pow(avgC, 7) + $4fa34aef7ce53011$var$pow(25, 7))));
    const a1p = a1 * (1 + G);
    const a2p = a2 * (1 + G);
    const C1p = $4fa34aef7ce53011$var$sqrt($4fa34aef7ce53011$var$pow(a1p, 2) + $4fa34aef7ce53011$var$pow(b1, 2));
    const C2p = $4fa34aef7ce53011$var$sqrt($4fa34aef7ce53011$var$pow(a2p, 2) + $4fa34aef7ce53011$var$pow(b2, 2));
    const avgCp = (C1p + C2p) / 2;
    const arctan1 = rad2deg($4fa34aef7ce53011$var$atan2(b1, a1p));
    const arctan2 = rad2deg($4fa34aef7ce53011$var$atan2(b2, a2p));
    const h1p = arctan1 >= 0 ? arctan1 : arctan1 + 360;
    const h2p = arctan2 >= 0 ? arctan2 : arctan2 + 360;
    const avgHp = $4fa34aef7ce53011$var$abs(h1p - h2p) > 180 ? (h1p + h2p + 360) / 2 : (h1p + h2p) / 2;
    const T = 1 - 0.17 * $4fa34aef7ce53011$var$cos(deg2rad(avgHp - 30)) + 0.24 * $4fa34aef7ce53011$var$cos(deg2rad(2 * avgHp)) + 0.32 * $4fa34aef7ce53011$var$cos(deg2rad(3 * avgHp + 6)) - 0.2 * $4fa34aef7ce53011$var$cos(deg2rad(4 * avgHp - 63));
    let deltaHp = h2p - h1p;
    deltaHp = $4fa34aef7ce53011$var$abs(deltaHp) <= 180 ? deltaHp : h2p <= h1p ? deltaHp + 360 : deltaHp - 360;
    deltaHp = 2 * $4fa34aef7ce53011$var$sqrt(C1p * C2p) * $4fa34aef7ce53011$var$sin(deg2rad(deltaHp) / 2);
    const deltaL = L2 - L1;
    const deltaCp = C2p - C1p;
    const sl = 1 + 0.015 * $4fa34aef7ce53011$var$pow(avgL - 50, 2) / $4fa34aef7ce53011$var$sqrt(20 + $4fa34aef7ce53011$var$pow(avgL - 50, 2));
    const sc = 1 + 0.045 * avgCp;
    const sh = 1 + 0.015 * avgCp * T;
    const deltaTheta = 30 * $4fa34aef7ce53011$var$exp(-$4fa34aef7ce53011$var$pow((avgHp - 275) / 25, 2));
    const Rc = 2 * $4fa34aef7ce53011$var$sqrt($4fa34aef7ce53011$var$pow(avgCp, 7) / ($4fa34aef7ce53011$var$pow(avgCp, 7) + $4fa34aef7ce53011$var$pow(25, 7)));
    const Rt = -Rc * $4fa34aef7ce53011$var$sin(2 * deg2rad(deltaTheta));
    const result = $4fa34aef7ce53011$var$sqrt($4fa34aef7ce53011$var$pow(deltaL / (Kl * sl), 2) + $4fa34aef7ce53011$var$pow(deltaCp / (Kc * sc), 2) + $4fa34aef7ce53011$var$pow(deltaHp / (Kh * sh), 2) + Rt * (deltaCp / (Kc * sc)) * (deltaHp / (Kh * sh)));
    return $4fa34aef7ce53011$var$max(0, $4fa34aef7ce53011$var$min(100, result));
}



function $b08edf62bea38a78$export$2e2bcd8739ae039(a, b, mode = 'lab') {
    // Delta E (CIE 1976)
    // see http://www.brucelindbloom.com/index.html?Equations.html
    a = new (0, $73c73657cae9064a$export$2e2bcd8739ae039)(a);
    b = new (0, $73c73657cae9064a$export$2e2bcd8739ae039)(b);
    const l1 = a.get(mode);
    const l2 = b.get(mode);
    let sum_sq = 0;
    for(let i in l1){
        const d = (l1[i] || 0) - (l2[i] || 0);
        sum_sq += d * d;
    }
    return Math.sqrt(sum_sq);
}



var $433baacaa82d6db3$export$2e2bcd8739ae039 = (...args)=>{
    try {
        new (0, $73c73657cae9064a$export$2e2bcd8739ae039)(...args);
        return true;
    // eslint-disable-next-line
    } catch (e) {
        return false;
    }
};



// some pre-defined color scales:



var $aece2f00be3b80cc$export$2e2bcd8739ae039 = {
    cool () {
        return (0, $24c5a8a3d239afb3$export$2e2bcd8739ae039)([
            (0, $311ec6bd16e186d1$export$2e2bcd8739ae039).hsl(180, 1, 0.9),
            (0, $311ec6bd16e186d1$export$2e2bcd8739ae039).hsl(250, 0.7, 0.4)
        ]);
    },
    hot () {
        return (0, $24c5a8a3d239afb3$export$2e2bcd8739ae039)([
            '#000',
            '#f00',
            '#ff0',
            '#fff'
        ], [
            0,
            0.25,
            0.75,
            1
        ]).mode('rgb');
    }
};



/**
    ColorBrewer colors for chroma.js

    Copyright (c) 2002 Cynthia Brewer, Mark Harrower, and The
    Pennsylvania State University.

    Licensed under the Apache License, Version 2.0 (the "License");
    you may not use this file except in compliance with the License.
    You may obtain a copy of the License at
    http://www.apache.org/licenses/LICENSE-2.0

    Unless required by applicable law or agreed to in writing, software distributed
    under the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
    CONDITIONS OF ANY KIND, either express or implied. See the License for the
    specific language governing permissions and limitations under the License.
*/ const $d91e88ca920c04af$var$colorbrewer = {
    // sequential
    OrRd: [
        '#fff7ec',
        '#fee8c8',
        '#fdd49e',
        '#fdbb84',
        '#fc8d59',
        '#ef6548',
        '#d7301f',
        '#b30000',
        '#7f0000'
    ],
    PuBu: [
        '#fff7fb',
        '#ece7f2',
        '#d0d1e6',
        '#a6bddb',
        '#74a9cf',
        '#3690c0',
        '#0570b0',
        '#045a8d',
        '#023858'
    ],
    BuPu: [
        '#f7fcfd',
        '#e0ecf4',
        '#bfd3e6',
        '#9ebcda',
        '#8c96c6',
        '#8c6bb1',
        '#88419d',
        '#810f7c',
        '#4d004b'
    ],
    Oranges: [
        '#fff5eb',
        '#fee6ce',
        '#fdd0a2',
        '#fdae6b',
        '#fd8d3c',
        '#f16913',
        '#d94801',
        '#a63603',
        '#7f2704'
    ],
    BuGn: [
        '#f7fcfd',
        '#e5f5f9',
        '#ccece6',
        '#99d8c9',
        '#66c2a4',
        '#41ae76',
        '#238b45',
        '#006d2c',
        '#00441b'
    ],
    YlOrBr: [
        '#ffffe5',
        '#fff7bc',
        '#fee391',
        '#fec44f',
        '#fe9929',
        '#ec7014',
        '#cc4c02',
        '#993404',
        '#662506'
    ],
    YlGn: [
        '#ffffe5',
        '#f7fcb9',
        '#d9f0a3',
        '#addd8e',
        '#78c679',
        '#41ab5d',
        '#238443',
        '#006837',
        '#004529'
    ],
    Reds: [
        '#fff5f0',
        '#fee0d2',
        '#fcbba1',
        '#fc9272',
        '#fb6a4a',
        '#ef3b2c',
        '#cb181d',
        '#a50f15',
        '#67000d'
    ],
    RdPu: [
        '#fff7f3',
        '#fde0dd',
        '#fcc5c0',
        '#fa9fb5',
        '#f768a1',
        '#dd3497',
        '#ae017e',
        '#7a0177',
        '#49006a'
    ],
    Greens: [
        '#f7fcf5',
        '#e5f5e0',
        '#c7e9c0',
        '#a1d99b',
        '#74c476',
        '#41ab5d',
        '#238b45',
        '#006d2c',
        '#00441b'
    ],
    YlGnBu: [
        '#ffffd9',
        '#edf8b1',
        '#c7e9b4',
        '#7fcdbb',
        '#41b6c4',
        '#1d91c0',
        '#225ea8',
        '#253494',
        '#081d58'
    ],
    Purples: [
        '#fcfbfd',
        '#efedf5',
        '#dadaeb',
        '#bcbddc',
        '#9e9ac8',
        '#807dba',
        '#6a51a3',
        '#54278f',
        '#3f007d'
    ],
    GnBu: [
        '#f7fcf0',
        '#e0f3db',
        '#ccebc5',
        '#a8ddb5',
        '#7bccc4',
        '#4eb3d3',
        '#2b8cbe',
        '#0868ac',
        '#084081'
    ],
    Greys: [
        '#ffffff',
        '#f0f0f0',
        '#d9d9d9',
        '#bdbdbd',
        '#969696',
        '#737373',
        '#525252',
        '#252525',
        '#000000'
    ],
    YlOrRd: [
        '#ffffcc',
        '#ffeda0',
        '#fed976',
        '#feb24c',
        '#fd8d3c',
        '#fc4e2a',
        '#e31a1c',
        '#bd0026',
        '#800026'
    ],
    PuRd: [
        '#f7f4f9',
        '#e7e1ef',
        '#d4b9da',
        '#c994c7',
        '#df65b0',
        '#e7298a',
        '#ce1256',
        '#980043',
        '#67001f'
    ],
    Blues: [
        '#f7fbff',
        '#deebf7',
        '#c6dbef',
        '#9ecae1',
        '#6baed6',
        '#4292c6',
        '#2171b5',
        '#08519c',
        '#08306b'
    ],
    PuBuGn: [
        '#fff7fb',
        '#ece2f0',
        '#d0d1e6',
        '#a6bddb',
        '#67a9cf',
        '#3690c0',
        '#02818a',
        '#016c59',
        '#014636'
    ],
    Viridis: [
        '#440154',
        '#482777',
        '#3f4a8a',
        '#31678e',
        '#26838f',
        '#1f9d8a',
        '#6cce5a',
        '#b6de2b',
        '#fee825'
    ],
    // diverging
    Spectral: [
        '#9e0142',
        '#d53e4f',
        '#f46d43',
        '#fdae61',
        '#fee08b',
        '#ffffbf',
        '#e6f598',
        '#abdda4',
        '#66c2a5',
        '#3288bd',
        '#5e4fa2'
    ],
    RdYlGn: [
        '#a50026',
        '#d73027',
        '#f46d43',
        '#fdae61',
        '#fee08b',
        '#ffffbf',
        '#d9ef8b',
        '#a6d96a',
        '#66bd63',
        '#1a9850',
        '#006837'
    ],
    RdBu: [
        '#67001f',
        '#b2182b',
        '#d6604d',
        '#f4a582',
        '#fddbc7',
        '#f7f7f7',
        '#d1e5f0',
        '#92c5de',
        '#4393c3',
        '#2166ac',
        '#053061'
    ],
    PiYG: [
        '#8e0152',
        '#c51b7d',
        '#de77ae',
        '#f1b6da',
        '#fde0ef',
        '#f7f7f7',
        '#e6f5d0',
        '#b8e186',
        '#7fbc41',
        '#4d9221',
        '#276419'
    ],
    PRGn: [
        '#40004b',
        '#762a83',
        '#9970ab',
        '#c2a5cf',
        '#e7d4e8',
        '#f7f7f7',
        '#d9f0d3',
        '#a6dba0',
        '#5aae61',
        '#1b7837',
        '#00441b'
    ],
    RdYlBu: [
        '#a50026',
        '#d73027',
        '#f46d43',
        '#fdae61',
        '#fee090',
        '#ffffbf',
        '#e0f3f8',
        '#abd9e9',
        '#74add1',
        '#4575b4',
        '#313695'
    ],
    BrBG: [
        '#543005',
        '#8c510a',
        '#bf812d',
        '#dfc27d',
        '#f6e8c3',
        '#f5f5f5',
        '#c7eae5',
        '#80cdc1',
        '#35978f',
        '#01665e',
        '#003c30'
    ],
    RdGy: [
        '#67001f',
        '#b2182b',
        '#d6604d',
        '#f4a582',
        '#fddbc7',
        '#ffffff',
        '#e0e0e0',
        '#bababa',
        '#878787',
        '#4d4d4d',
        '#1a1a1a'
    ],
    PuOr: [
        '#7f3b08',
        '#b35806',
        '#e08214',
        '#fdb863',
        '#fee0b6',
        '#f7f7f7',
        '#d8daeb',
        '#b2abd2',
        '#8073ac',
        '#542788',
        '#2d004b'
    ],
    // qualitative
    Set2: [
        '#66c2a5',
        '#fc8d62',
        '#8da0cb',
        '#e78ac3',
        '#a6d854',
        '#ffd92f',
        '#e5c494',
        '#b3b3b3'
    ],
    Accent: [
        '#7fc97f',
        '#beaed4',
        '#fdc086',
        '#ffff99',
        '#386cb0',
        '#f0027f',
        '#bf5b17',
        '#666666'
    ],
    Set1: [
        '#e41a1c',
        '#377eb8',
        '#4daf4a',
        '#984ea3',
        '#ff7f00',
        '#ffff33',
        '#a65628',
        '#f781bf',
        '#999999'
    ],
    Set3: [
        '#8dd3c7',
        '#ffffb3',
        '#bebada',
        '#fb8072',
        '#80b1d3',
        '#fdb462',
        '#b3de69',
        '#fccde5',
        '#d9d9d9',
        '#bc80bd',
        '#ccebc5',
        '#ffed6f'
    ],
    Dark2: [
        '#1b9e77',
        '#d95f02',
        '#7570b3',
        '#e7298a',
        '#66a61e',
        '#e6ab02',
        '#a6761d',
        '#666666'
    ],
    Paired: [
        '#a6cee3',
        '#1f78b4',
        '#b2df8a',
        '#33a02c',
        '#fb9a99',
        '#e31a1c',
        '#fdbf6f',
        '#ff7f00',
        '#cab2d6',
        '#6a3d9a',
        '#ffff99',
        '#b15928'
    ],
    Pastel2: [
        '#b3e2cd',
        '#fdcdac',
        '#cbd5e8',
        '#f4cae4',
        '#e6f5c9',
        '#fff2ae',
        '#f1e2cc',
        '#cccccc'
    ],
    Pastel1: [
        '#fbb4ae',
        '#b3cde3',
        '#ccebc5',
        '#decbe4',
        '#fed9a6',
        '#ffffcc',
        '#e5d8bd',
        '#fddaec',
        '#f2f2f2'
    ]
};
// add lowercase aliases for case-insensitive matches
for (let key of Object.keys($d91e88ca920c04af$var$colorbrewer))$d91e88ca920c04af$var$colorbrewer[key.toLowerCase()] = $d91e88ca920c04af$var$colorbrewer[key];
var $d91e88ca920c04af$export$2e2bcd8739ae039 = $d91e88ca920c04af$var$colorbrewer;


Object.assign((0, $311ec6bd16e186d1$export$2e2bcd8739ae039), {
    average: $12dd7fa91b00d6d8$export$2e2bcd8739ae039,
    bezier: $c7a2d3d03020c6d6$export$2e2bcd8739ae039,
    blend: $36d9f8b7360a85ad$export$2e2bcd8739ae039,
    cubehelix: $8090a903719cad5a$export$2e2bcd8739ae039,
    mix: $36049a9f16a5dcac$export$2e2bcd8739ae039,
    interpolate: (0, $36049a9f16a5dcac$export$2e2bcd8739ae039),
    random: $8f48ef595c9cfd89$export$2e2bcd8739ae039,
    scale: $24c5a8a3d239afb3$export$2e2bcd8739ae039,
    analyze: $9bdbebf464fb72d3$export$7cbcccfbecde6416,
    contrast: $dc105be0f4d2b0ec$export$2e2bcd8739ae039,
    deltaE: $4fa34aef7ce53011$export$2e2bcd8739ae039,
    distance: $b08edf62bea38a78$export$2e2bcd8739ae039,
    limits: $9bdbebf464fb72d3$export$e331ca4ad6a82555,
    valid: $433baacaa82d6db3$export$2e2bcd8739ae039,
    scales: $aece2f00be3b80cc$export$2e2bcd8739ae039,
    input: $8f39e66366edca09$export$2e2bcd8739ae039,
    colors: $c5c068cfa2d42134$export$2e2bcd8739ae039,
    brewer: $d91e88ca920c04af$export$2e2bcd8739ae039
});
var $7e3b89534f2c3158$export$2e2bcd8739ae039 = (0, $311ec6bd16e186d1$export$2e2bcd8739ae039);


const $54b47fc030b7b21e$var$nameElement = document.getElementById("name");
const $54b47fc030b7b21e$var$reloadButton = document.getElementById("reload");
const $54b47fc030b7b21e$var$reloadSvg = document.getElementsByClassName("js-reload-svg")[0];
const $54b47fc030b7b21e$var$chars = $54b47fc030b7b21e$var$nameElement.getElementsByClassName("js-char");
const $54b47fc030b7b21e$var$aboutEN = document.getElementById("about");
const $54b47fc030b7b21e$var$aboutNL = document.getElementById("info");
let $54b47fc030b7b21e$var$aboutIsOpen = false;
// set the reload svg to 0deg
$54b47fc030b7b21e$var$reloadSvg.style.transform = "rotate(0deg)";
// a function that generates a random number between min and max
function $54b47fc030b7b21e$var$random(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}
// a calculation function that returns a number after 0 if the number is larger than 360
// or a number before 360 if the number is smaller than 0
function $54b47fc030b7b21e$var$calcHue(num) {
    if (num > 360) return num - 360;
    else if (num < 0) return num + 360;
    else return num;
}
const $54b47fc030b7b21e$var$setRandomColors = function() {
    const baseHue = $54b47fc030b7b21e$var$random(0, 360);
    const complimentaryHue = $54b47fc030b7b21e$var$calcHue(baseHue + 180);
    const splitComplimentaryHue1 = $54b47fc030b7b21e$var$calcHue(complimentaryHue + 30);
    const splitComplimentaryHue2 = $54b47fc030b7b21e$var$calcHue(complimentaryHue - 30);
    const analogousHue1 = $54b47fc030b7b21e$var$calcHue(baseHue + 30);
    const analogousHue2 = $54b47fc030b7b21e$var$calcHue(baseHue - 30);
    const triadicHue1 = $54b47fc030b7b21e$var$calcHue(baseHue + 120);
    const triadicHue2 = $54b47fc030b7b21e$var$calcHue(baseHue + 240);
    const tetradHue1 = $54b47fc030b7b21e$var$calcHue(baseHue + 90);
    const tetradHue3 = $54b47fc030b7b21e$var$calcHue(baseHue + 270);
    // create an array of all the hue values
    const fittingHues = [
        baseHue,
        complimentaryHue,
        splitComplimentaryHue1,
        splitComplimentaryHue2,
        analogousHue1,
        analogousHue2,
        triadicHue1,
        triadicHue2,
        tetradHue1,
        tetradHue3
    ];
    // get a rondom hue
    const fittingHue = fittingHues[$54b47fc030b7b21e$var$random(0, fittingHues.length - 1)];
    // const fittingHue = fittingHues[9];
    // const colorBack = randomColor({
    //     luminosity: 'light',
    //     hue: baseHue
    // });
    const colorBack = (0, $7e3b89534f2c3158$export$2e2bcd8739ae039).hcl(baseHue, 30, 90);
    const colorFront = (0, (/*@__PURE__*/$parcel$interopDefault($fjfo2)))({
        luminosity: "dark",
        hue: fittingHue
    });
    // const colorFront = chroma.hcl(fittingHue, random(80, 100), random(40, 70));
    // create an array of color objects
    const colors = [
        colorBack,
        colorFront
    ];
    // set the css variable for the background color
    document.documentElement.style.setProperty("--global-backgroundColor", colors[0]);
    // set the css variable for the text color
    document.documentElement.style.setProperty("--global-textColor", colors[1]);
// save the colors to local storage
// localStorage.setItem('backgroundColor', colors[0]);
// localStorage.setItem('textColor', colors[1]);
};
function $54b47fc030b7b21e$var$setRandomFontProps() {
    const maxTotalWght = 2400;
    let wght1 = $54b47fc030b7b21e$var$random(200, 400);
    let wght2 = $54b47fc030b7b21e$var$random(400, 600);
    let wght3 = $54b47fc030b7b21e$var$random(600, 800);
    let totalWght = wght1 + wght2 + wght3;
    let wght4 = maxTotalWght - totalWght;
    if (wght4 > 800) wght4 = 800;
    let wghts = [
        wght1,
        wght2,
        wght3,
        wght4
    ];
    // shuffle the array
    wghts.sort(()=>Math.random() - 0.5);
    for(var i = 0; i < $54b47fc030b7b21e$var$chars.length; i++)// chars[i].style.setProperty('font-variation-settings', '"wght" ' + random(400, 800) + ', "wdth" ' + 1);
    $54b47fc030b7b21e$var$chars[i].style.setProperty("font-variation-settings", '"wght" ' + wghts[i] + ', "wdth" ' + 1);
}
// create a function that rotates an element every time the function is called
function $54b47fc030b7b21e$var$rotateElement(element) {
    // get the current rotation value of the button
    let currentRotation = element.style.transform;
    // rotate the button 360 degrees plus the current rotation
    element.style.transform = "rotate(" + (parseInt(currentRotation.split("(")[1].split("deg")[0]) + 360) + "deg)";
}
// fetch colors and setrandom stuff when the r key is pressed only when aboutIsOpen is false
document.onkeypress = function(e) {
    if (e.keyCode == 114 && !$54b47fc030b7b21e$var$aboutIsOpen) {
        $54b47fc030b7b21e$var$setRandomFontProps();
        $54b47fc030b7b21e$var$setRandomColors();
        $54b47fc030b7b21e$var$rotateElement($54b47fc030b7b21e$var$reloadSvg);
    }
};
// fetch colors and setrandom stuff when the reload button is pressed with an event listener when aboutIsOpen is false
$54b47fc030b7b21e$var$reloadButton.addEventListener("click", function() {
    if (!$54b47fc030b7b21e$var$aboutIsOpen) {
        $54b47fc030b7b21e$var$setRandomFontProps();
        $54b47fc030b7b21e$var$setRandomColors();
        $54b47fc030b7b21e$var$rotateElement($54b47fc030b7b21e$var$reloadSvg);
    }
});
// document.addEventListener('DOMContentLoaded', function () {
//     // if local storage doesnt have a value for backgroundColor or textColor, set random colors
//     if (!localStorage.getItem('backgroundColor') || !localStorage.getItem('textColor')) {
//         setRandomColors();
//     } else {
//         // set the css variable for the background color
//         document.documentElement.style.setProperty('--global-backgroundColor', localStorage.getItem('backgroundColor'));
//         // set the css variable for the text color
//         document.documentElement.style.setProperty('--global-textColor', localStorage.getItem('textColor'));
//     }
// });
// remove the loading class from the html tag and add a minumum loading time of 1 second
document.onreadystatechange = function() {
    if (document.readyState == "complete") {
        // if local storage doesnt have an item with a key that starts with font-variation-settings, set random font props
        // if (!localStorage.getItem('font-variation-settings-0')) {
        //     setRandomFontProps();
        // } else {
        //     // loop through all chars and set their font variation settings to the font variation settings from local storage
        //     for (var i = 0; i < chars.length; i++) {
        //         chars[i].style.setProperty('font-variation-settings', localStorage.getItem('font-variation-settings-' + i));
        //     }
        // }
        $54b47fc030b7b21e$var$setRandomFontProps();
        setTimeout(function() {
            document.querySelector("html").classList.remove("loading");
        }, 1000);
    }
};
// toggle about when #about is in the url
if (window.location.hash === "#about") {
    $54b47fc030b7b21e$var$aboutEN.showModal();
    $54b47fc030b7b21e$var$aboutIsOpen = true;
}
if (window.location.hash === "#info") {
    $54b47fc030b7b21e$var$aboutNL.showModal();
    $54b47fc030b7b21e$var$aboutIsOpen = true;
}
// toggle about when the back and forward buttons are pressed
window.onpopstate = function(event) {
    if (window.location.hash === "#about") {
        if (!$54b47fc030b7b21e$var$aboutEN.open) $54b47fc030b7b21e$var$aboutEN.showModal();
        $54b47fc030b7b21e$var$aboutIsOpen = true;
    } else if (window.location.hash === "#info") {
        if (!$54b47fc030b7b21e$var$aboutNL.open) $54b47fc030b7b21e$var$aboutNL.showModal();
        $54b47fc030b7b21e$var$aboutIsOpen = true;
    } else {
        if ($54b47fc030b7b21e$var$aboutEN.open) $54b47fc030b7b21e$var$aboutEN.close();
        if ($54b47fc030b7b21e$var$aboutNL.open) $54b47fc030b7b21e$var$aboutNL.close();
        $54b47fc030b7b21e$var$aboutIsOpen = false;
    }
};
// close dialog on close button click
document.querySelectorAll(".js-toggle-about").forEach((btn)=>{
    btn.addEventListener("click", ()=>{
        if ($54b47fc030b7b21e$var$aboutEN.open) $54b47fc030b7b21e$var$aboutEN.close();
        if ($54b47fc030b7b21e$var$aboutNL.open) $54b47fc030b7b21e$var$aboutNL.close();
        $54b47fc030b7b21e$var$aboutIsOpen = false;
        history.replaceState(null, "", window.location.pathname);
    });
});
// sync hash when dialog is closed via Escape key
$54b47fc030b7b21e$var$aboutEN.addEventListener("close", ()=>{
    $54b47fc030b7b21e$var$aboutIsOpen = false;
    if (window.location.hash === "#about") history.replaceState(null, "", window.location.pathname);
});
$54b47fc030b7b21e$var$aboutNL.addEventListener("close", ()=>{
    $54b47fc030b7b21e$var$aboutIsOpen = false;
    if (window.location.hash === "#info") history.replaceState(null, "", window.location.pathname);
});
// check the language of the browser and hide about-link-nl if it is not nl
if (navigator.language !== "nl") document.querySelector("#aboutLinkNL").style.display = "none";
else {
    document.querySelector("#aboutLinkNL").style.display = "block";
    document.querySelector("#aboutLinkEN").style.display = "none";
}
var $93fe0ca3e8a620dd$exports = {};
$93fe0ca3e8a620dd$exports = import.meta.resolve("7yeQP");


if ("serviceWorker" in navigator) navigator.serviceWorker.register($93fe0ca3e8a620dd$exports).then((reg)=>{
    console.log("Registration successful", reg);
}).catch((e)=>console.error("Error during service worker registration:", e));
else console.warn("Service Worker is not supported");


//# sourceMappingURL=repo.6838e353.js.map
